var __defProp = Object.defineProperty;
var __returnValue = (v) => v;
function __exportSetter(name, newValue) {
  this[name] = __returnValue.bind(null, newValue);
}
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: __exportSetter.bind(all, name)
    });
};

// dist/fp.js
var exports_fp = {};
__export(exports_fp, {
  yearsToQuarters: () => yearsToQuarters2,
  yearsToMonths: () => yearsToMonths2,
  yearsToDays: () => yearsToDays2,
  weeksToDays: () => weeksToDays2,
  transpose: () => transpose2,
  toDate: () => toDate2,
  subYearsWithOptions: () => subYearsWithOptions,
  subYears: () => subYears2,
  subWithOptions: () => subWithOptions,
  subWeeksWithOptions: () => subWeeksWithOptions,
  subWeeks: () => subWeeks2,
  subSecondsWithOptions: () => subSecondsWithOptions,
  subSeconds: () => subSeconds2,
  subQuartersWithOptions: () => subQuartersWithOptions,
  subQuarters: () => subQuarters2,
  subMonthsWithOptions: () => subMonthsWithOptions,
  subMonths: () => subMonths2,
  subMinutesWithOptions: () => subMinutesWithOptions,
  subMinutes: () => subMinutes2,
  subMillisecondsWithOptions: () => subMillisecondsWithOptions,
  subMilliseconds: () => subMilliseconds2,
  subISOWeekYearsWithOptions: () => subISOWeekYearsWithOptions,
  subISOWeekYears: () => subISOWeekYears2,
  subHoursWithOptions: () => subHoursWithOptions,
  subHours: () => subHours2,
  subDaysWithOptions: () => subDaysWithOptions,
  subDays: () => subDays2,
  subBusinessDaysWithOptions: () => subBusinessDaysWithOptions,
  subBusinessDays: () => subBusinessDays2,
  sub: () => sub2,
  startOfYearWithOptions: () => startOfYearWithOptions,
  startOfYear: () => startOfYear2,
  startOfWeekYearWithOptions: () => startOfWeekYearWithOptions,
  startOfWeekYear: () => startOfWeekYear2,
  startOfWeekWithOptions: () => startOfWeekWithOptions,
  startOfWeek: () => startOfWeek2,
  startOfSecondWithOptions: () => startOfSecondWithOptions,
  startOfSecond: () => startOfSecond2,
  startOfQuarterWithOptions: () => startOfQuarterWithOptions,
  startOfQuarter: () => startOfQuarter2,
  startOfMonthWithOptions: () => startOfMonthWithOptions,
  startOfMonth: () => startOfMonth2,
  startOfMinuteWithOptions: () => startOfMinuteWithOptions,
  startOfMinute: () => startOfMinute2,
  startOfISOWeekYearWithOptions: () => startOfISOWeekYearWithOptions,
  startOfISOWeekYear: () => startOfISOWeekYear2,
  startOfISOWeekWithOptions: () => startOfISOWeekWithOptions,
  startOfISOWeek: () => startOfISOWeek2,
  startOfHourWithOptions: () => startOfHourWithOptions,
  startOfHour: () => startOfHour2,
  startOfDecadeWithOptions: () => startOfDecadeWithOptions,
  startOfDecade: () => startOfDecade2,
  startOfDayWithOptions: () => startOfDayWithOptions,
  startOfDay: () => startOfDay2,
  setYearWithOptions: () => setYearWithOptions,
  setYear: () => setYear2,
  setWithOptions: () => setWithOptions,
  setWeekYearWithOptions: () => setWeekYearWithOptions,
  setWeekYear: () => setWeekYear2,
  setWeekWithOptions: () => setWeekWithOptions,
  setWeek: () => setWeek2,
  setSecondsWithOptions: () => setSecondsWithOptions,
  setSeconds: () => setSeconds2,
  setQuarterWithOptions: () => setQuarterWithOptions,
  setQuarter: () => setQuarter2,
  setMonthWithOptions: () => setMonthWithOptions,
  setMonth: () => setMonth2,
  setMinutesWithOptions: () => setMinutesWithOptions,
  setMinutes: () => setMinutes2,
  setMillisecondsWithOptions: () => setMillisecondsWithOptions,
  setMilliseconds: () => setMilliseconds2,
  setISOWeekYearWithOptions: () => setISOWeekYearWithOptions,
  setISOWeekYear: () => setISOWeekYear2,
  setISOWeekWithOptions: () => setISOWeekWithOptions,
  setISOWeek: () => setISOWeek2,
  setISODayWithOptions: () => setISODayWithOptions,
  setISODay: () => setISODay2,
  setHoursWithOptions: () => setHoursWithOptions,
  setHours: () => setHours2,
  setDayWithOptions: () => setDayWithOptions,
  setDayOfYearWithOptions: () => setDayOfYearWithOptions,
  setDayOfYear: () => setDayOfYear2,
  setDay: () => setDay2,
  setDateWithOptions: () => setDateWithOptions,
  setDate: () => setDate2,
  set: () => set2,
  secondsToMinutes: () => secondsToMinutes2,
  secondsToMilliseconds: () => secondsToMilliseconds2,
  secondsToHours: () => secondsToHours2,
  roundToNearestMinutesWithOptions: () => roundToNearestMinutesWithOptions,
  roundToNearestMinutes: () => roundToNearestMinutes2,
  roundToNearestHoursWithOptions: () => roundToNearestHoursWithOptions,
  roundToNearestHours: () => roundToNearestHours2,
  quartersToYears: () => quartersToYears2,
  quartersToMonths: () => quartersToMonths2,
  previousWednesdayWithOptions: () => previousWednesdayWithOptions,
  previousWednesday: () => previousWednesday2,
  previousTuesdayWithOptions: () => previousTuesdayWithOptions,
  previousTuesday: () => previousTuesday2,
  previousThursdayWithOptions: () => previousThursdayWithOptions,
  previousThursday: () => previousThursday2,
  previousSundayWithOptions: () => previousSundayWithOptions,
  previousSunday: () => previousSunday2,
  previousSaturdayWithOptions: () => previousSaturdayWithOptions,
  previousSaturday: () => previousSaturday2,
  previousMondayWithOptions: () => previousMondayWithOptions,
  previousMonday: () => previousMonday2,
  previousFridayWithOptions: () => previousFridayWithOptions,
  previousFriday: () => previousFriday2,
  previousDayWithOptions: () => previousDayWithOptions,
  previousDay: () => previousDay2,
  parseWithOptions: () => parseWithOptions,
  parseJSONWithOptions: () => parseJSONWithOptions,
  parseJSON: () => parseJSON2,
  parseISOWithOptions: () => parseISOWithOptions,
  parseISO: () => parseISO2,
  parse: () => parse2,
  nextWednesdayWithOptions: () => nextWednesdayWithOptions,
  nextWednesday: () => nextWednesday2,
  nextTuesdayWithOptions: () => nextTuesdayWithOptions,
  nextTuesday: () => nextTuesday2,
  nextThursdayWithOptions: () => nextThursdayWithOptions,
  nextThursday: () => nextThursday2,
  nextSundayWithOptions: () => nextSundayWithOptions,
  nextSunday: () => nextSunday2,
  nextSaturdayWithOptions: () => nextSaturdayWithOptions,
  nextSaturday: () => nextSaturday2,
  nextMondayWithOptions: () => nextMondayWithOptions,
  nextMonday: () => nextMonday2,
  nextFridayWithOptions: () => nextFridayWithOptions,
  nextFriday: () => nextFriday2,
  nextDayWithOptions: () => nextDayWithOptions,
  nextDay: () => nextDay2,
  monthsToYears: () => monthsToYears2,
  monthsToQuarters: () => monthsToQuarters2,
  minutesToSeconds: () => minutesToSeconds2,
  minutesToMilliseconds: () => minutesToMilliseconds2,
  minutesToHours: () => minutesToHours2,
  minWithOptions: () => minWithOptions,
  min: () => min2,
  millisecondsToSeconds: () => millisecondsToSeconds2,
  millisecondsToMinutes: () => millisecondsToMinutes2,
  millisecondsToHours: () => millisecondsToHours2,
  milliseconds: () => milliseconds2,
  maxWithOptions: () => maxWithOptions,
  max: () => max2,
  lightFormat: () => lightFormat2,
  lastDayOfYearWithOptions: () => lastDayOfYearWithOptions,
  lastDayOfYear: () => lastDayOfYear2,
  lastDayOfWeekWithOptions: () => lastDayOfWeekWithOptions,
  lastDayOfWeek: () => lastDayOfWeek2,
  lastDayOfQuarterWithOptions: () => lastDayOfQuarterWithOptions,
  lastDayOfQuarter: () => lastDayOfQuarter2,
  lastDayOfMonthWithOptions: () => lastDayOfMonthWithOptions,
  lastDayOfMonth: () => lastDayOfMonth2,
  lastDayOfISOWeekYearWithOptions: () => lastDayOfISOWeekYearWithOptions,
  lastDayOfISOWeekYear: () => lastDayOfISOWeekYear2,
  lastDayOfISOWeekWithOptions: () => lastDayOfISOWeekWithOptions,
  lastDayOfISOWeek: () => lastDayOfISOWeek2,
  lastDayOfDecadeWithOptions: () => lastDayOfDecadeWithOptions,
  lastDayOfDecade: () => lastDayOfDecade2,
  isWithinIntervalWithOptions: () => isWithinIntervalWithOptions,
  isWithinInterval: () => isWithinInterval2,
  isWeekendWithOptions: () => isWeekendWithOptions,
  isWeekend: () => isWeekend2,
  isWednesdayWithOptions: () => isWednesdayWithOptions,
  isWednesday: () => isWednesday2,
  isValid: () => isValid2,
  isTuesdayWithOptions: () => isTuesdayWithOptions,
  isTuesday: () => isTuesday2,
  isThursdayWithOptions: () => isThursdayWithOptions,
  isThursday: () => isThursday2,
  isSundayWithOptions: () => isSundayWithOptions,
  isSunday: () => isSunday2,
  isSaturdayWithOptions: () => isSaturdayWithOptions,
  isSaturday: () => isSaturday2,
  isSameYearWithOptions: () => isSameYearWithOptions,
  isSameYear: () => isSameYear2,
  isSameWeekWithOptions: () => isSameWeekWithOptions,
  isSameWeek: () => isSameWeek2,
  isSameSecond: () => isSameSecond2,
  isSameQuarterWithOptions: () => isSameQuarterWithOptions,
  isSameQuarter: () => isSameQuarter2,
  isSameMonthWithOptions: () => isSameMonthWithOptions,
  isSameMonth: () => isSameMonth2,
  isSameMinute: () => isSameMinute2,
  isSameISOWeekYearWithOptions: () => isSameISOWeekYearWithOptions,
  isSameISOWeekYear: () => isSameISOWeekYear2,
  isSameISOWeekWithOptions: () => isSameISOWeekWithOptions,
  isSameISOWeek: () => isSameISOWeek2,
  isSameHourWithOptions: () => isSameHourWithOptions,
  isSameHour: () => isSameHour2,
  isSameDayWithOptions: () => isSameDayWithOptions,
  isSameDay: () => isSameDay2,
  isMondayWithOptions: () => isMondayWithOptions,
  isMonday: () => isMonday2,
  isMatchWithOptions: () => isMatchWithOptions,
  isMatch: () => isMatch2,
  isLeapYearWithOptions: () => isLeapYearWithOptions,
  isLeapYear: () => isLeapYear2,
  isLastDayOfMonthWithOptions: () => isLastDayOfMonthWithOptions,
  isLastDayOfMonth: () => isLastDayOfMonth2,
  isFridayWithOptions: () => isFridayWithOptions,
  isFriday: () => isFriday2,
  isFirstDayOfMonthWithOptions: () => isFirstDayOfMonthWithOptions,
  isFirstDayOfMonth: () => isFirstDayOfMonth2,
  isExists: () => isExists2,
  isEqual: () => isEqual2,
  isDate: () => isDate2,
  isBefore: () => isBefore2,
  isAfter: () => isAfter2,
  intlFormatDistanceWithOptions: () => intlFormatDistanceWithOptions,
  intlFormatDistance: () => intlFormatDistance2,
  intlFormat: () => intlFormat2,
  intervalWithOptions: () => intervalWithOptions,
  intervalToDurationWithOptions: () => intervalToDurationWithOptions,
  intervalToDuration: () => intervalToDuration2,
  interval: () => interval2,
  hoursToSeconds: () => hoursToSeconds2,
  hoursToMinutes: () => hoursToMinutes2,
  hoursToMilliseconds: () => hoursToMilliseconds2,
  getYearWithOptions: () => getYearWithOptions,
  getYear: () => getYear2,
  getWeeksInMonthWithOptions: () => getWeeksInMonthWithOptions,
  getWeeksInMonth: () => getWeeksInMonth2,
  getWeekYearWithOptions: () => getWeekYearWithOptions,
  getWeekYear: () => getWeekYear2,
  getWeekWithOptions: () => getWeekWithOptions,
  getWeekOfMonthWithOptions: () => getWeekOfMonthWithOptions,
  getWeekOfMonth: () => getWeekOfMonth2,
  getWeek: () => getWeek2,
  getUnixTime: () => getUnixTime2,
  getTime: () => getTime2,
  getSeconds: () => getSeconds2,
  getQuarterWithOptions: () => getQuarterWithOptions,
  getQuarter: () => getQuarter2,
  getOverlappingDaysInIntervals: () => getOverlappingDaysInIntervals2,
  getMonthWithOptions: () => getMonthWithOptions,
  getMonth: () => getMonth2,
  getMinutesWithOptions: () => getMinutesWithOptions,
  getMinutes: () => getMinutes2,
  getMilliseconds: () => getMilliseconds2,
  getISOWeeksInYearWithOptions: () => getISOWeeksInYearWithOptions,
  getISOWeeksInYear: () => getISOWeeksInYear2,
  getISOWeekYearWithOptions: () => getISOWeekYearWithOptions,
  getISOWeekYear: () => getISOWeekYear2,
  getISOWeekWithOptions: () => getISOWeekWithOptions,
  getISOWeek: () => getISOWeek2,
  getISODayWithOptions: () => getISODayWithOptions,
  getISODay: () => getISODay2,
  getHoursWithOptions: () => getHoursWithOptions,
  getHours: () => getHours2,
  getDecadeWithOptions: () => getDecadeWithOptions,
  getDecade: () => getDecade2,
  getDaysInYearWithOptions: () => getDaysInYearWithOptions,
  getDaysInYear: () => getDaysInYear2,
  getDaysInMonthWithOptions: () => getDaysInMonthWithOptions,
  getDaysInMonth: () => getDaysInMonth2,
  getDayWithOptions: () => getDayWithOptions,
  getDayOfYearWithOptions: () => getDayOfYearWithOptions,
  getDayOfYear: () => getDayOfYear2,
  getDay: () => getDay2,
  getDateWithOptions: () => getDateWithOptions,
  getDate: () => getDate2,
  fromUnixTimeWithOptions: () => fromUnixTimeWithOptions,
  fromUnixTime: () => fromUnixTime2,
  formatWithOptions: () => formatWithOptions,
  formatRelativeWithOptions: () => formatRelativeWithOptions,
  formatRelative: () => formatRelative3,
  formatRFC7231: () => formatRFC72312,
  formatRFC3339WithOptions: () => formatRFC3339WithOptions,
  formatRFC3339: () => formatRFC33392,
  formatISOWithOptions: () => formatISOWithOptions,
  formatISODuration: () => formatISODuration2,
  formatISO9075WithOptions: () => formatISO9075WithOptions,
  formatISO9075: () => formatISO90752,
  formatISO: () => formatISO2,
  formatDurationWithOptions: () => formatDurationWithOptions,
  formatDuration: () => formatDuration2,
  formatDistanceWithOptions: () => formatDistanceWithOptions,
  formatDistanceStrictWithOptions: () => formatDistanceStrictWithOptions,
  formatDistanceStrict: () => formatDistanceStrict2,
  formatDistance: () => formatDistance3,
  format: () => format2,
  endOfYearWithOptions: () => endOfYearWithOptions,
  endOfYear: () => endOfYear2,
  endOfWeekWithOptions: () => endOfWeekWithOptions,
  endOfWeek: () => endOfWeek2,
  endOfSecondWithOptions: () => endOfSecondWithOptions,
  endOfSecond: () => endOfSecond2,
  endOfQuarterWithOptions: () => endOfQuarterWithOptions,
  endOfQuarter: () => endOfQuarter2,
  endOfMonthWithOptions: () => endOfMonthWithOptions,
  endOfMonth: () => endOfMonth2,
  endOfMinuteWithOptions: () => endOfMinuteWithOptions,
  endOfMinute: () => endOfMinute2,
  endOfISOWeekYearWithOptions: () => endOfISOWeekYearWithOptions,
  endOfISOWeekYear: () => endOfISOWeekYear2,
  endOfISOWeekWithOptions: () => endOfISOWeekWithOptions,
  endOfISOWeek: () => endOfISOWeek2,
  endOfHourWithOptions: () => endOfHourWithOptions,
  endOfHour: () => endOfHour2,
  endOfDecadeWithOptions: () => endOfDecadeWithOptions,
  endOfDecade: () => endOfDecade2,
  endOfDayWithOptions: () => endOfDayWithOptions,
  endOfDay: () => endOfDay2,
  eachYearOfIntervalWithOptions: () => eachYearOfIntervalWithOptions,
  eachYearOfInterval: () => eachYearOfInterval2,
  eachWeekendOfYearWithOptions: () => eachWeekendOfYearWithOptions,
  eachWeekendOfYear: () => eachWeekendOfYear2,
  eachWeekendOfMonthWithOptions: () => eachWeekendOfMonthWithOptions,
  eachWeekendOfMonth: () => eachWeekendOfMonth2,
  eachWeekendOfIntervalWithOptions: () => eachWeekendOfIntervalWithOptions,
  eachWeekendOfInterval: () => eachWeekendOfInterval2,
  eachWeekOfIntervalWithOptions: () => eachWeekOfIntervalWithOptions,
  eachWeekOfInterval: () => eachWeekOfInterval2,
  eachQuarterOfIntervalWithOptions: () => eachQuarterOfIntervalWithOptions,
  eachQuarterOfInterval: () => eachQuarterOfInterval2,
  eachMonthOfIntervalWithOptions: () => eachMonthOfIntervalWithOptions,
  eachMonthOfInterval: () => eachMonthOfInterval2,
  eachMinuteOfIntervalWithOptions: () => eachMinuteOfIntervalWithOptions,
  eachMinuteOfInterval: () => eachMinuteOfInterval2,
  eachHourOfIntervalWithOptions: () => eachHourOfIntervalWithOptions,
  eachHourOfInterval: () => eachHourOfInterval2,
  eachDayOfIntervalWithOptions: () => eachDayOfIntervalWithOptions,
  eachDayOfInterval: () => eachDayOfInterval2,
  differenceInYearsWithOptions: () => differenceInYearsWithOptions,
  differenceInYears: () => differenceInYears2,
  differenceInWeeksWithOptions: () => differenceInWeeksWithOptions,
  differenceInWeeks: () => differenceInWeeks2,
  differenceInSecondsWithOptions: () => differenceInSecondsWithOptions,
  differenceInSeconds: () => differenceInSeconds2,
  differenceInQuartersWithOptions: () => differenceInQuartersWithOptions,
  differenceInQuarters: () => differenceInQuarters2,
  differenceInMonthsWithOptions: () => differenceInMonthsWithOptions,
  differenceInMonths: () => differenceInMonths2,
  differenceInMinutesWithOptions: () => differenceInMinutesWithOptions,
  differenceInMinutes: () => differenceInMinutes2,
  differenceInMilliseconds: () => differenceInMilliseconds2,
  differenceInISOWeekYearsWithOptions: () => differenceInISOWeekYearsWithOptions,
  differenceInISOWeekYears: () => differenceInISOWeekYears2,
  differenceInHoursWithOptions: () => differenceInHoursWithOptions,
  differenceInHours: () => differenceInHours2,
  differenceInDaysWithOptions: () => differenceInDaysWithOptions,
  differenceInDays: () => differenceInDays2,
  differenceInCalendarYearsWithOptions: () => differenceInCalendarYearsWithOptions,
  differenceInCalendarYears: () => differenceInCalendarYears2,
  differenceInCalendarWeeksWithOptions: () => differenceInCalendarWeeksWithOptions,
  differenceInCalendarWeeks: () => differenceInCalendarWeeks2,
  differenceInCalendarQuartersWithOptions: () => differenceInCalendarQuartersWithOptions,
  differenceInCalendarQuarters: () => differenceInCalendarQuarters2,
  differenceInCalendarMonthsWithOptions: () => differenceInCalendarMonthsWithOptions,
  differenceInCalendarMonths: () => differenceInCalendarMonths2,
  differenceInCalendarISOWeeksWithOptions: () => differenceInCalendarISOWeeksWithOptions,
  differenceInCalendarISOWeeks: () => differenceInCalendarISOWeeks2,
  differenceInCalendarISOWeekYearsWithOptions: () => differenceInCalendarISOWeekYearsWithOptions,
  differenceInCalendarISOWeekYears: () => differenceInCalendarISOWeekYears2,
  differenceInCalendarDaysWithOptions: () => differenceInCalendarDaysWithOptions,
  differenceInCalendarDays: () => differenceInCalendarDays2,
  differenceInBusinessDaysWithOptions: () => differenceInBusinessDaysWithOptions,
  differenceInBusinessDays: () => differenceInBusinessDays2,
  daysToWeeks: () => daysToWeeks2,
  constructFrom: () => constructFrom2,
  compareDesc: () => compareDesc2,
  compareAsc: () => compareAsc2,
  closestToWithOptions: () => closestToWithOptions,
  closestTo: () => closestTo2,
  closestIndexTo: () => closestIndexTo2,
  clampWithOptions: () => clampWithOptions,
  clamp: () => clamp2,
  areIntervalsOverlappingWithOptions: () => areIntervalsOverlappingWithOptions,
  areIntervalsOverlapping: () => areIntervalsOverlapping2,
  addYearsWithOptions: () => addYearsWithOptions,
  addYears: () => addYears2,
  addWithOptions: () => addWithOptions,
  addWeeksWithOptions: () => addWeeksWithOptions,
  addWeeks: () => addWeeks2,
  addSecondsWithOptions: () => addSecondsWithOptions,
  addSeconds: () => addSeconds2,
  addQuartersWithOptions: () => addQuartersWithOptions,
  addQuarters: () => addQuarters2,
  addMonthsWithOptions: () => addMonthsWithOptions,
  addMonths: () => addMonths2,
  addMinutesWithOptions: () => addMinutesWithOptions,
  addMinutes: () => addMinutes2,
  addMillisecondsWithOptions: () => addMillisecondsWithOptions,
  addMilliseconds: () => addMilliseconds2,
  addISOWeekYearsWithOptions: () => addISOWeekYearsWithOptions,
  addISOWeekYears: () => addISOWeekYears2,
  addHoursWithOptions: () => addHoursWithOptions,
  addHours: () => addHours2,
  addDaysWithOptions: () => addDaysWithOptions,
  addDays: () => addDays2,
  addBusinessDaysWithOptions: () => addBusinessDaysWithOptions,
  addBusinessDays: () => addBusinessDays2,
  add: () => add2
});

// dist/constants.js
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
var minTime = -maxTime;
var millisecondsInWeek = 604800000;
var millisecondsInDay = 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minutesInYear = 525600;
var minutesInMonth = 43200;
var minutesInDay = 1440;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;
var constructFromSymbol = Symbol.for("constructDateFrom");

// dist/constructFrom.js
function constructFrom(date, value) {
  if (typeof date === "function")
    return date(value);
  if (date && typeof date === "object" && constructFromSymbol in date)
    return date[constructFromSymbol](value);
  if (date instanceof Date)
    return new date.constructor(value);
  return new Date(value);
}

// dist/toDate.js
function toDate(argument, context) {
  return constructFrom(context || argument, argument);
}

// dist/addDays.js
function addDays(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount))
    return constructFrom(options?.in || date, NaN);
  if (!amount)
    return _date;
  _date.setDate(_date.getDate() + amount);
  return _date;
}

// dist/addMonths.js
function addMonths(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount))
    return constructFrom(options?.in || date, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = _date.getDate();
  const endOfDesiredMonth = constructFrom(options?.in || date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return _date;
  }
}

// dist/add.js
function add(date, duration, options) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const _date = toDate(date, options?.in);
  const dateWithMonths = months || years ? addMonths(_date, months + years * 12) : _date;
  const dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1000;
  return constructFrom(options?.in || date, +dateWithDays + msToAdd);
}

// dist/fp/_lib/convertToFP.js
function convertToFP(fn, arity, curriedArgs = []) {
  return curriedArgs.length >= arity ? fn(...curriedArgs.slice(0, arity).reverse()) : (...args) => convertToFP(fn, arity, curriedArgs.concat(args));
}

// dist/fp/add.js
var add2 = convertToFP(add, 2);
// dist/isSaturday.js
function isSaturday(date, options) {
  return toDate(date, options?.in).getDay() === 6;
}

// dist/isSunday.js
function isSunday(date, options) {
  return toDate(date, options?.in).getDay() === 0;
}

// dist/isWeekend.js
function isWeekend(date, options) {
  const day = toDate(date, options?.in).getDay();
  return day === 0 || day === 6;
}

// dist/addBusinessDays.js
function addBusinessDays(date, amount, options) {
  const _date = toDate(date, options?.in);
  const startedOnWeekend = isWeekend(_date, options);
  if (isNaN(amount))
    return constructFrom(options?.in, NaN);
  const hours = _date.getHours();
  const sign = amount < 0 ? -1 : 1;
  const fullWeeks = Math.trunc(amount / 5);
  _date.setDate(_date.getDate() + fullWeeks * 7);
  let restDays = Math.abs(amount % 5);
  while (restDays > 0) {
    _date.setDate(_date.getDate() + sign);
    if (!isWeekend(_date, options))
      restDays -= 1;
  }
  if (startedOnWeekend && isWeekend(_date, options) && amount !== 0) {
    if (isSaturday(_date, options))
      _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
    if (isSunday(_date, options))
      _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
  }
  _date.setHours(hours);
  return _date;
}

// dist/fp/addBusinessDays.js
var addBusinessDays2 = convertToFP(addBusinessDays, 2);
// dist/fp/addBusinessDaysWithOptions.js
var addBusinessDaysWithOptions = convertToFP(addBusinessDays, 3);
// dist/fp/addDays.js
var addDays2 = convertToFP(addDays, 2);
// dist/fp/addDaysWithOptions.js
var addDaysWithOptions = convertToFP(addDays, 3);
// dist/addMilliseconds.js
function addMilliseconds(date, amount, options) {
  return constructFrom(options?.in || date, +toDate(date) + amount);
}

// dist/addHours.js
function addHours(date, amount, options) {
  return addMilliseconds(date, amount * millisecondsInHour, options);
}

// dist/fp/addHours.js
var addHours2 = convertToFP(addHours, 2);
// dist/fp/addHoursWithOptions.js
var addHoursWithOptions = convertToFP(addHours, 3);
// dist/_lib/defaultOptions.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

// dist/startOfWeek.js
function startOfWeek(date, options) {
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// dist/startOfISOWeek.js
function startOfISOWeek(date, options) {
  return startOfWeek(date, { ...options, weekStartsOn: 1 });
}

// dist/getISOWeekYear.js
function getISOWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(_date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(_date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// dist/_lib/getTimezoneOffsetInMilliseconds.js
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

// dist/_lib/normalizeDates.js
function normalizeDates(context, ...dates) {
  const normalize = constructFrom.bind(null, context || dates.find((date) => typeof date === "object"));
  return dates.map(normalize);
}

// dist/startOfDay.js
function startOfDay(date, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// dist/differenceInCalendarDays.js
function differenceInCalendarDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const laterStartOfDay = startOfDay(laterDate_);
  const earlierStartOfDay = startOfDay(earlierDate_);
  const laterTimestamp = +laterStartOfDay - getTimezoneOffsetInMilliseconds(laterStartOfDay);
  const earlierTimestamp = +earlierStartOfDay - getTimezoneOffsetInMilliseconds(earlierStartOfDay);
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInDay);
}

// dist/startOfISOWeekYear.js
function startOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuary = constructFrom(options?.in || date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

// dist/setISOWeekYear.js
function setISOWeekYear(date, weekYear, options) {
  let _date = toDate(date, options?.in);
  const diff = differenceInCalendarDays(_date, startOfISOWeekYear(_date, options));
  const fourthOfJanuary = constructFrom(options?.in || date, 0);
  fourthOfJanuary.setFullYear(weekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  _date = startOfISOWeekYear(fourthOfJanuary);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

// dist/addISOWeekYears.js
function addISOWeekYears(date, amount, options) {
  return setISOWeekYear(date, getISOWeekYear(date, options) + amount, options);
}

// dist/fp/addISOWeekYears.js
var addISOWeekYears2 = convertToFP(addISOWeekYears, 2);
// dist/fp/addISOWeekYearsWithOptions.js
var addISOWeekYearsWithOptions = convertToFP(addISOWeekYears, 3);
// dist/fp/addMilliseconds.js
var addMilliseconds2 = convertToFP(addMilliseconds, 2);
// dist/fp/addMillisecondsWithOptions.js
var addMillisecondsWithOptions = convertToFP(addMilliseconds, 3);
// dist/addMinutes.js
function addMinutes(date, amount, options) {
  const _date = toDate(date, options?.in);
  _date.setTime(_date.getTime() + amount * millisecondsInMinute);
  return _date;
}

// dist/fp/addMinutes.js
var addMinutes2 = convertToFP(addMinutes, 2);
// dist/fp/addMinutesWithOptions.js
var addMinutesWithOptions = convertToFP(addMinutes, 3);
// dist/fp/addMonths.js
var addMonths2 = convertToFP(addMonths, 2);
// dist/fp/addMonthsWithOptions.js
var addMonthsWithOptions = convertToFP(addMonths, 3);
// dist/addQuarters.js
function addQuarters(date, amount, options) {
  return addMonths(date, amount * 3, options);
}

// dist/fp/addQuarters.js
var addQuarters2 = convertToFP(addQuarters, 2);
// dist/fp/addQuartersWithOptions.js
var addQuartersWithOptions = convertToFP(addQuarters, 3);
// dist/addSeconds.js
function addSeconds(date, amount, options) {
  return addMilliseconds(date, amount * 1000, options);
}

// dist/fp/addSeconds.js
var addSeconds2 = convertToFP(addSeconds, 2);
// dist/fp/addSecondsWithOptions.js
var addSecondsWithOptions = convertToFP(addSeconds, 3);
// dist/addWeeks.js
function addWeeks(date, amount, options) {
  return addDays(date, amount * 7, options);
}

// dist/fp/addWeeks.js
var addWeeks2 = convertToFP(addWeeks, 2);
// dist/fp/addWeeksWithOptions.js
var addWeeksWithOptions = convertToFP(addWeeks, 3);
// dist/fp/addWithOptions.js
var addWithOptions = convertToFP(add, 3);
// dist/addYears.js
function addYears(date, amount, options) {
  return addMonths(date, amount * 12, options);
}

// dist/fp/addYears.js
var addYears2 = convertToFP(addYears, 2);
// dist/fp/addYearsWithOptions.js
var addYearsWithOptions = convertToFP(addYears, 3);
// dist/areIntervalsOverlapping.js
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  const [leftStartTime, leftEndTime] = [
    +toDate(intervalLeft.start, options?.in),
    +toDate(intervalLeft.end, options?.in)
  ].sort((a, b) => a - b);
  const [rightStartTime, rightEndTime] = [
    +toDate(intervalRight.start, options?.in),
    +toDate(intervalRight.end, options?.in)
  ].sort((a, b) => a - b);
  if (options?.inclusive)
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

// dist/fp/areIntervalsOverlapping.js
var areIntervalsOverlapping2 = convertToFP(areIntervalsOverlapping, 2);
// dist/fp/areIntervalsOverlappingWithOptions.js
var areIntervalsOverlappingWithOptions = convertToFP(areIntervalsOverlapping, 3);
// dist/max.js
function max(dates, options) {
  let result;
  let context = options?.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);
    const date_ = toDate(date, context);
    if (!result || result < date_ || isNaN(+date_))
      result = date_;
  });
  return constructFrom(context, result || NaN);
}

// dist/min.js
function min(dates, options) {
  let result;
  let context = options?.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);
    const date_ = toDate(date, context);
    if (!result || result > date_ || isNaN(+date_))
      result = date_;
  });
  return constructFrom(context, result || NaN);
}

// dist/clamp.js
function clamp(date, interval, options) {
  const [date_, start, end] = normalizeDates(options?.in, date, interval.start, interval.end);
  return min([max([date_, start], options), end], options);
}

// dist/fp/clamp.js
var clamp2 = convertToFP(clamp, 2);
// dist/fp/clampWithOptions.js
var clampWithOptions = convertToFP(clamp, 3);
// dist/closestIndexTo.js
function closestIndexTo(dateToCompare, dates) {
  const timeToCompare = +toDate(dateToCompare);
  if (isNaN(timeToCompare))
    return NaN;
  let result;
  let minDistance;
  dates.forEach((date, index) => {
    const date_ = toDate(date);
    if (isNaN(+date_)) {
      result = NaN;
      minDistance = NaN;
      return;
    }
    const distance = Math.abs(timeToCompare - +date_);
    if (result == null || distance < minDistance) {
      result = index;
      minDistance = distance;
    }
  });
  return result;
}

// dist/fp/closestIndexTo.js
var closestIndexTo2 = convertToFP(closestIndexTo, 2);
// dist/closestTo.js
function closestTo(dateToCompare, dates, options) {
  const [dateToCompare_, ...dates_] = normalizeDates(options?.in, dateToCompare, ...dates);
  const index = closestIndexTo(dateToCompare_, dates_);
  if (typeof index === "number" && isNaN(index))
    return constructFrom(dateToCompare_, NaN);
  if (index !== undefined)
    return dates_[index];
}

// dist/fp/closestTo.js
var closestTo2 = convertToFP(closestTo, 2);
// dist/fp/closestToWithOptions.js
var closestToWithOptions = convertToFP(closestTo, 3);
// dist/compareAsc.js
function compareAsc(dateLeft, dateRight) {
  const diff = +toDate(dateLeft) - +toDate(dateRight);
  if (diff < 0)
    return -1;
  else if (diff > 0)
    return 1;
  return diff;
}

// dist/fp/compareAsc.js
var compareAsc2 = convertToFP(compareAsc, 2);
// dist/compareDesc.js
function compareDesc(dateLeft, dateRight) {
  const diff = +toDate(dateLeft) - +toDate(dateRight);
  if (diff > 0)
    return -1;
  else if (diff < 0)
    return 1;
  return diff;
}

// dist/fp/compareDesc.js
var compareDesc2 = convertToFP(compareDesc, 2);
// dist/fp/constructFrom.js
var constructFrom2 = convertToFP(constructFrom, 2);
// dist/daysToWeeks.js
function daysToWeeks(days) {
  const result = Math.trunc(days / daysInWeek);
  return result === 0 ? 0 : result;
}

// dist/fp/daysToWeeks.js
var daysToWeeks2 = convertToFP(daysToWeeks, 1);
// dist/isSameDay.js
function isSameDay(laterDate, earlierDate, options) {
  const [dateLeft_, dateRight_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfDay(dateLeft_) === +startOfDay(dateRight_);
}

// dist/isDate.js
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

// dist/isValid.js
function isValid(date) {
  return !(!isDate(date) && typeof date !== "number" || isNaN(+toDate(date)));
}

// dist/differenceInBusinessDays.js
function differenceInBusinessDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  if (!isValid(laterDate_) || !isValid(earlierDate_))
    return NaN;
  const diff = differenceInCalendarDays(laterDate_, earlierDate_);
  const sign = diff < 0 ? -1 : 1;
  const weeks = Math.trunc(diff / 7);
  let result = weeks * 5;
  let movingDate = addDays(earlierDate_, weeks * 7);
  while (!isSameDay(laterDate_, movingDate)) {
    result += isWeekend(movingDate, options) ? 0 : sign;
    movingDate = addDays(movingDate, sign);
  }
  return result === 0 ? 0 : result;
}

// dist/fp/differenceInBusinessDays.js
var differenceInBusinessDays2 = convertToFP(differenceInBusinessDays, 2);
// dist/fp/differenceInBusinessDaysWithOptions.js
var differenceInBusinessDaysWithOptions = convertToFP(differenceInBusinessDays, 3);
// dist/fp/differenceInCalendarDays.js
var differenceInCalendarDays2 = convertToFP(differenceInCalendarDays, 2);
// dist/fp/differenceInCalendarDaysWithOptions.js
var differenceInCalendarDaysWithOptions = convertToFP(differenceInCalendarDays, 3);
// dist/differenceInCalendarISOWeekYears.js
function differenceInCalendarISOWeekYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return getISOWeekYear(laterDate_, options) - getISOWeekYear(earlierDate_, options);
}

// dist/fp/differenceInCalendarISOWeekYears.js
var differenceInCalendarISOWeekYears2 = convertToFP(differenceInCalendarISOWeekYears, 2);
// dist/fp/differenceInCalendarISOWeekYearsWithOptions.js
var differenceInCalendarISOWeekYearsWithOptions = convertToFP(differenceInCalendarISOWeekYears, 3);
// dist/differenceInCalendarISOWeeks.js
function differenceInCalendarISOWeeks(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const startOfISOWeekLeft = startOfISOWeek(laterDate_);
  const startOfISOWeekRight = startOfISOWeek(earlierDate_);
  const timestampLeft = +startOfISOWeekLeft - getTimezoneOffsetInMilliseconds(startOfISOWeekLeft);
  const timestampRight = +startOfISOWeekRight - getTimezoneOffsetInMilliseconds(startOfISOWeekRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInWeek);
}

// dist/fp/differenceInCalendarISOWeeks.js
var differenceInCalendarISOWeeks2 = convertToFP(differenceInCalendarISOWeeks, 2);
// dist/fp/differenceInCalendarISOWeeksWithOptions.js
var differenceInCalendarISOWeeksWithOptions = convertToFP(differenceInCalendarISOWeeks, 3);
// dist/differenceInCalendarMonths.js
function differenceInCalendarMonths(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
  const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
  return yearsDiff * 12 + monthsDiff;
}

// dist/fp/differenceInCalendarMonths.js
var differenceInCalendarMonths2 = convertToFP(differenceInCalendarMonths, 2);
// dist/fp/differenceInCalendarMonthsWithOptions.js
var differenceInCalendarMonthsWithOptions = convertToFP(differenceInCalendarMonths, 3);
// dist/getQuarter.js
function getQuarter(date, options) {
  const _date = toDate(date, options?.in);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}

// dist/differenceInCalendarQuarters.js
function differenceInCalendarQuarters(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
  const quartersDiff = getQuarter(laterDate_) - getQuarter(earlierDate_);
  return yearsDiff * 4 + quartersDiff;
}

// dist/fp/differenceInCalendarQuarters.js
var differenceInCalendarQuarters2 = convertToFP(differenceInCalendarQuarters, 2);
// dist/fp/differenceInCalendarQuartersWithOptions.js
var differenceInCalendarQuartersWithOptions = convertToFP(differenceInCalendarQuarters, 3);
// dist/differenceInCalendarWeeks.js
function differenceInCalendarWeeks(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const laterStartOfWeek = startOfWeek(laterDate_, options);
  const earlierStartOfWeek = startOfWeek(earlierDate_, options);
  const laterTimestamp = +laterStartOfWeek - getTimezoneOffsetInMilliseconds(laterStartOfWeek);
  const earlierTimestamp = +earlierStartOfWeek - getTimezoneOffsetInMilliseconds(earlierStartOfWeek);
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInWeek);
}

// dist/fp/differenceInCalendarWeeks.js
var differenceInCalendarWeeks2 = convertToFP(differenceInCalendarWeeks, 2);
// dist/fp/differenceInCalendarWeeksWithOptions.js
var differenceInCalendarWeeksWithOptions = convertToFP(differenceInCalendarWeeks, 3);
// dist/differenceInCalendarYears.js
function differenceInCalendarYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return laterDate_.getFullYear() - earlierDate_.getFullYear();
}

// dist/fp/differenceInCalendarYears.js
var differenceInCalendarYears2 = convertToFP(differenceInCalendarYears, 2);
// dist/fp/differenceInCalendarYearsWithOptions.js
var differenceInCalendarYearsWithOptions = convertToFP(differenceInCalendarYears, 3);
// dist/differenceInDays.js
function differenceInDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const sign = compareLocalAsc(laterDate_, earlierDate_);
  const difference = Math.abs(differenceInCalendarDays(laterDate_, earlierDate_));
  laterDate_.setDate(laterDate_.getDate() - sign * difference);
  const isLastDayNotFull = Number(compareLocalAsc(laterDate_, earlierDate_) === -sign);
  const result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function compareLocalAsc(laterDate, earlierDate) {
  const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
  if (diff < 0)
    return -1;
  if (diff > 0)
    return 1;
  return diff;
}

// dist/fp/differenceInDays.js
var differenceInDays2 = convertToFP(differenceInDays, 2);
// dist/fp/differenceInDaysWithOptions.js
var differenceInDaysWithOptions = convertToFP(differenceInDays, 3);
// dist/_lib/getRoundingMethod.js
function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    return result === 0 ? 0 : result;
  };
}

// dist/differenceInHours.js
function differenceInHours(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const diff = (+laterDate_ - +earlierDate_) / millisecondsInHour;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// dist/fp/differenceInHours.js
var differenceInHours2 = convertToFP(differenceInHours, 2);
// dist/fp/differenceInHoursWithOptions.js
var differenceInHoursWithOptions = convertToFP(differenceInHours, 3);
// dist/subISOWeekYears.js
function subISOWeekYears(date, amount, options) {
  return addISOWeekYears(date, -amount, options);
}

// dist/differenceInISOWeekYears.js
function differenceInISOWeekYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const sign = compareAsc(laterDate_, earlierDate_);
  const diff = Math.abs(differenceInCalendarISOWeekYears(laterDate_, earlierDate_, options));
  const adjustedDate = subISOWeekYears(laterDate_, sign * diff, options);
  const isLastISOWeekYearNotFull = Number(compareAsc(adjustedDate, earlierDate_) === -sign);
  const result = sign * (diff - isLastISOWeekYearNotFull);
  return result === 0 ? 0 : result;
}

// dist/fp/differenceInISOWeekYears.js
var differenceInISOWeekYears2 = convertToFP(differenceInISOWeekYears, 2);
// dist/fp/differenceInISOWeekYearsWithOptions.js
var differenceInISOWeekYearsWithOptions = convertToFP(differenceInISOWeekYears, 3);
// dist/differenceInMilliseconds.js
function differenceInMilliseconds(laterDate, earlierDate) {
  return +toDate(laterDate) - +toDate(earlierDate);
}

// dist/fp/differenceInMilliseconds.js
var differenceInMilliseconds2 = convertToFP(differenceInMilliseconds, 2);
// dist/differenceInMinutes.js
function differenceInMinutes(dateLeft, dateRight, options) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// dist/fp/differenceInMinutes.js
var differenceInMinutes2 = convertToFP(differenceInMinutes, 2);
// dist/fp/differenceInMinutesWithOptions.js
var differenceInMinutesWithOptions = convertToFP(differenceInMinutes, 3);
// dist/endOfDay.js
function endOfDay(date, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// dist/endOfMonth.js
function endOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// dist/isLastDayOfMonth.js
function isLastDayOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  return +endOfDay(_date, options) === +endOfMonth(_date, options);
}

// dist/differenceInMonths.js
function differenceInMonths(laterDate, earlierDate, options) {
  const [laterDate_, workingLaterDate, earlierDate_] = normalizeDates(options?.in, laterDate, laterDate, earlierDate);
  const sign = compareAsc(workingLaterDate, earlierDate_);
  const difference = Math.abs(differenceInCalendarMonths(workingLaterDate, earlierDate_));
  if (difference < 1)
    return 0;
  if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27)
    workingLaterDate.setDate(30);
  workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
  let isLastMonthNotFull = compareAsc(workingLaterDate, earlierDate_) === -sign;
  if (isLastDayOfMonth(laterDate_) && difference === 1 && compareAsc(laterDate_, earlierDate_) === 1) {
    isLastMonthNotFull = false;
  }
  const result = sign * (difference - +isLastMonthNotFull);
  return result === 0 ? 0 : result;
}

// dist/fp/differenceInMonths.js
var differenceInMonths2 = convertToFP(differenceInMonths, 2);
// dist/fp/differenceInMonthsWithOptions.js
var differenceInMonthsWithOptions = convertToFP(differenceInMonths, 3);
// dist/differenceInQuarters.js
function differenceInQuarters(laterDate, earlierDate, options) {
  const diff = differenceInMonths(laterDate, earlierDate, options) / 3;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// dist/fp/differenceInQuarters.js
var differenceInQuarters2 = convertToFP(differenceInQuarters, 2);
// dist/fp/differenceInQuartersWithOptions.js
var differenceInQuartersWithOptions = convertToFP(differenceInQuarters, 3);
// dist/differenceInSeconds.js
function differenceInSeconds(laterDate, earlierDate, options) {
  const diff = differenceInMilliseconds(laterDate, earlierDate) / 1000;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// dist/fp/differenceInSeconds.js
var differenceInSeconds2 = convertToFP(differenceInSeconds, 2);
// dist/fp/differenceInSecondsWithOptions.js
var differenceInSecondsWithOptions = convertToFP(differenceInSeconds, 3);
// dist/differenceInWeeks.js
function differenceInWeeks(laterDate, earlierDate, options) {
  const diff = differenceInDays(laterDate, earlierDate, options) / 7;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

// dist/fp/differenceInWeeks.js
var differenceInWeeks2 = convertToFP(differenceInWeeks, 2);
// dist/fp/differenceInWeeksWithOptions.js
var differenceInWeeksWithOptions = convertToFP(differenceInWeeks, 3);
// dist/differenceInYears.js
function differenceInYears(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  const sign = compareAsc(laterDate_, earlierDate_);
  const diff = Math.abs(differenceInCalendarYears(laterDate_, earlierDate_));
  laterDate_.setFullYear(1584);
  earlierDate_.setFullYear(1584);
  const partial = compareAsc(laterDate_, earlierDate_) === -sign;
  const result = sign * (diff - +partial);
  return result === 0 ? 0 : result;
}

// dist/fp/differenceInYears.js
var differenceInYears2 = convertToFP(differenceInYears, 2);
// dist/fp/differenceInYearsWithOptions.js
var differenceInYearsWithOptions = convertToFP(differenceInYears, 3);
// dist/_lib/normalizeInterval.js
function normalizeInterval(context, interval) {
  const [start, end] = normalizeDates(context, interval.start, interval.end);
  return { start, end };
}

// dist/eachDayOfInterval.js
function eachDayOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setDate(date.getDate() + step);
    date.setHours(0, 0, 0, 0);
  }
  return reversed ? dates.reverse() : dates;
}

// dist/fp/eachDayOfInterval.js
var eachDayOfInterval2 = convertToFP(eachDayOfInterval, 1);
// dist/fp/eachDayOfIntervalWithOptions.js
var eachDayOfIntervalWithOptions = convertToFP(eachDayOfInterval, 2);
// dist/eachHourOfInterval.js
function eachHourOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setMinutes(0, 0, 0);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setHours(date.getHours() + step);
  }
  return reversed ? dates.reverse() : dates;
}

// dist/fp/eachHourOfInterval.js
var eachHourOfInterval2 = convertToFP(eachHourOfInterval, 1);
// dist/fp/eachHourOfIntervalWithOptions.js
var eachHourOfIntervalWithOptions = convertToFP(eachHourOfInterval, 2);
// dist/eachMinuteOfInterval.js
function eachMinuteOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  start.setSeconds(0, 0);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  let date = reversed ? end : start;
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date = addMinutes(date, step);
  }
  return reversed ? dates.reverse() : dates;
}

// dist/fp/eachMinuteOfInterval.js
var eachMinuteOfInterval2 = convertToFP(eachMinuteOfInterval, 1);
// dist/fp/eachMinuteOfIntervalWithOptions.js
var eachMinuteOfIntervalWithOptions = convertToFP(eachMinuteOfInterval, 2);
// dist/eachMonthOfInterval.js
function eachMonthOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  date.setDate(1);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setMonth(date.getMonth() + step);
  }
  return reversed ? dates.reverse() : dates;
}

// dist/fp/eachMonthOfInterval.js
var eachMonthOfInterval2 = convertToFP(eachMonthOfInterval, 1);
// dist/fp/eachMonthOfIntervalWithOptions.js
var eachMonthOfIntervalWithOptions = convertToFP(eachMonthOfInterval, 2);
// dist/startOfQuarter.js
function startOfQuarter(date, options) {
  const _date = toDate(date, options?.in);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3;
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// dist/eachQuarterOfInterval.js
function eachQuarterOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +startOfQuarter(start) : +startOfQuarter(end);
  let date = reversed ? startOfQuarter(end) : startOfQuarter(start);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date = addQuarters(date, step);
  }
  return reversed ? dates.reverse() : dates;
}

// dist/fp/eachQuarterOfInterval.js
var eachQuarterOfInterval2 = convertToFP(eachQuarterOfInterval, 1);
// dist/fp/eachQuarterOfIntervalWithOptions.js
var eachQuarterOfIntervalWithOptions = convertToFP(eachQuarterOfInterval, 2);
// dist/eachWeekOfInterval.js
function eachWeekOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const startDateWeek = reversed ? startOfWeek(end, options) : startOfWeek(start, options);
  const endDateWeek = reversed ? startOfWeek(start, options) : startOfWeek(end, options);
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);
  const endTime = +endDateWeek.getTime();
  let currentDate = startDateWeek;
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+currentDate <= endTime) {
    currentDate.setHours(0);
    dates.push(constructFrom(start, currentDate));
    currentDate = addWeeks(currentDate, step);
    currentDate.setHours(15);
  }
  return reversed ? dates.reverse() : dates;
}

// dist/fp/eachWeekOfInterval.js
var eachWeekOfInterval2 = convertToFP(eachWeekOfInterval, 1);
// dist/fp/eachWeekOfIntervalWithOptions.js
var eachWeekOfIntervalWithOptions = convertToFP(eachWeekOfInterval, 2);
// dist/eachWeekendOfInterval.js
function eachWeekendOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  const dateInterval = eachDayOfInterval({ start, end }, options);
  const weekends = [];
  let index = 0;
  while (index < dateInterval.length) {
    const date = dateInterval[index++];
    if (isWeekend(date))
      weekends.push(constructFrom(start, date));
  }
  return weekends;
}

// dist/fp/eachWeekendOfInterval.js
var eachWeekendOfInterval2 = convertToFP(eachWeekendOfInterval, 1);
// dist/fp/eachWeekendOfIntervalWithOptions.js
var eachWeekendOfIntervalWithOptions = convertToFP(eachWeekendOfInterval, 2);
// dist/startOfMonth.js
function startOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// dist/eachWeekendOfMonth.js
function eachWeekendOfMonth(date, options) {
  const start = startOfMonth(date, options);
  const end = endOfMonth(date, options);
  return eachWeekendOfInterval({ start, end }, options);
}

// dist/fp/eachWeekendOfMonth.js
var eachWeekendOfMonth2 = convertToFP(eachWeekendOfMonth, 1);
// dist/fp/eachWeekendOfMonthWithOptions.js
var eachWeekendOfMonthWithOptions = convertToFP(eachWeekendOfMonth, 2);
// dist/endOfYear.js
function endOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// dist/startOfYear.js
function startOfYear(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setFullYear(date_.getFullYear(), 0, 1);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

// dist/eachWeekendOfYear.js
function eachWeekendOfYear(date, options) {
  const start = startOfYear(date, options);
  const end = endOfYear(date, options);
  return eachWeekendOfInterval({ start, end }, options);
}

// dist/fp/eachWeekendOfYear.js
var eachWeekendOfYear2 = convertToFP(eachWeekendOfYear, 1);
// dist/fp/eachWeekendOfYearWithOptions.js
var eachWeekendOfYearWithOptions = convertToFP(eachWeekendOfYear, 2);
// dist/eachYearOfInterval.js
function eachYearOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options?.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  date.setMonth(0, 1);
  let step = options?.step ?? 1;
  if (!step)
    return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setFullYear(date.getFullYear() + step);
  }
  return reversed ? dates.reverse() : dates;
}

// dist/fp/eachYearOfInterval.js
var eachYearOfInterval2 = convertToFP(eachYearOfInterval, 1);
// dist/fp/eachYearOfIntervalWithOptions.js
var eachYearOfIntervalWithOptions = convertToFP(eachYearOfInterval, 2);
// dist/fp/endOfDay.js
var endOfDay2 = convertToFP(endOfDay, 1);
// dist/fp/endOfDayWithOptions.js
var endOfDayWithOptions = convertToFP(endOfDay, 2);
// dist/endOfDecade.js
function endOfDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 11, 31);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// dist/fp/endOfDecade.js
var endOfDecade2 = convertToFP(endOfDecade, 1);
// dist/fp/endOfDecadeWithOptions.js
var endOfDecadeWithOptions = convertToFP(endOfDecade, 2);
// dist/endOfHour.js
function endOfHour(date, options) {
  const _date = toDate(date, options?.in);
  _date.setMinutes(59, 59, 999);
  return _date;
}

// dist/fp/endOfHour.js
var endOfHour2 = convertToFP(endOfHour, 1);
// dist/fp/endOfHourWithOptions.js
var endOfHourWithOptions = convertToFP(endOfHour, 2);
// dist/endOfWeek.js
function endOfWeek(date, options) {
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// dist/endOfISOWeek.js
function endOfISOWeek(date, options) {
  return endOfWeek(date, { ...options, weekStartsOn: 1 });
}

// dist/fp/endOfISOWeek.js
var endOfISOWeek2 = convertToFP(endOfISOWeek, 1);
// dist/fp/endOfISOWeekWithOptions.js
var endOfISOWeekWithOptions = convertToFP(endOfISOWeek, 2);
// dist/endOfISOWeekYear.js
function endOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuaryOfNextYear = constructFrom(options?.in || date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const _date = startOfISOWeek(fourthOfJanuaryOfNextYear, options);
  _date.setMilliseconds(_date.getMilliseconds() - 1);
  return _date;
}

// dist/fp/endOfISOWeekYear.js
var endOfISOWeekYear2 = convertToFP(endOfISOWeekYear, 1);
// dist/fp/endOfISOWeekYearWithOptions.js
var endOfISOWeekYearWithOptions = convertToFP(endOfISOWeekYear, 2);
// dist/endOfMinute.js
function endOfMinute(date, options) {
  const _date = toDate(date, options?.in);
  _date.setSeconds(59, 999);
  return _date;
}

// dist/fp/endOfMinute.js
var endOfMinute2 = convertToFP(endOfMinute, 1);
// dist/fp/endOfMinuteWithOptions.js
var endOfMinuteWithOptions = convertToFP(endOfMinute, 2);
// dist/fp/endOfMonth.js
var endOfMonth2 = convertToFP(endOfMonth, 1);
// dist/fp/endOfMonthWithOptions.js
var endOfMonthWithOptions = convertToFP(endOfMonth, 2);
// dist/endOfQuarter.js
function endOfQuarter(date, options) {
  const _date = toDate(date, options?.in);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3 + 3;
  _date.setMonth(month, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// dist/fp/endOfQuarter.js
var endOfQuarter2 = convertToFP(endOfQuarter, 1);
// dist/fp/endOfQuarterWithOptions.js
var endOfQuarterWithOptions = convertToFP(endOfQuarter, 2);
// dist/endOfSecond.js
function endOfSecond(date, options) {
  const _date = toDate(date, options?.in);
  _date.setMilliseconds(999);
  return _date;
}

// dist/fp/endOfSecond.js
var endOfSecond2 = convertToFP(endOfSecond, 1);
// dist/fp/endOfSecondWithOptions.js
var endOfSecondWithOptions = convertToFP(endOfSecond, 2);
// dist/fp/endOfWeek.js
var endOfWeek2 = convertToFP(endOfWeek, 1);
// dist/fp/endOfWeekWithOptions.js
var endOfWeekWithOptions = convertToFP(endOfWeek, 2);
// dist/fp/endOfYear.js
var endOfYear2 = convertToFP(endOfYear, 1);
// dist/fp/endOfYearWithOptions.js
var endOfYearWithOptions = convertToFP(endOfYear, 2);
// dist/locale/en-US/_lib/formatDistance.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};

// dist/locale/_lib/buildFormatLongFn.js
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

// dist/locale/en-US/_lib/formatLong.js
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};

// dist/locale/en-US/_lib/formatRelative.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];

// dist/locale/_lib/buildLocalizeFn.js
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}

// dist/locale/en-US/_lib/localize.js
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};

// dist/locale/_lib/buildMatchFn.js
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : findKey(parsePatterns, (pattern) => pattern.test(matchedString));
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return;
}
function findIndex(array, predicate) {
  for (let key = 0;key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return;
}

// dist/locale/_lib/buildMatchPatternFn.js
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}

// dist/locale/en-US/_lib/match.js
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};

// dist/locale/en-US.js
var enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
// dist/getDayOfYear.js
function getDayOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

// dist/getISOWeek.js
function getISOWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}

// dist/getWeekYear.js
function getWeekYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions2.firstWeekContainsDate ?? defaultOptions2.locale?.options?.firstWeekContainsDate ?? 1;
  const firstWeekOfNextYear = constructFrom(options?.in || date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(options?.in || date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (+_date >= +startOfNextYear) {
    return year + 1;
  } else if (+_date >= +startOfThisYear) {
    return year;
  } else {
    return year - 1;
  }
}

// dist/startOfWeekYear.js
function startOfWeekYear(date, options) {
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions2.firstWeekContainsDate ?? defaultOptions2.locale?.options?.firstWeekContainsDate ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(options?.in || date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

// dist/getWeek.js
function getWeek(date, options) {
  const _date = toDate(date, options?.in);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}

// dist/_lib/addLeadingZeros.js
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

// dist/_lib/format/lightFormatters.js
var lightFormatters = {
  y(date, token) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

// dist/_lib/format/formatters.js
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  G: function(date, token, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  y: function(date, token, localize2) {
    if (token === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  Y: function(date, token, localize2, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function(date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  L: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  w: function(date, token, localize2, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function(date, token, localize2) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  D: function(date, token, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(date, token, localize2) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(date, token, localize2) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  H: function(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  K: function(date, token, localize2) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function(date, token, localize2) {
    let hours = date.getHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  s: function(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(+date / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function(date, token, _localize) {
    return addLeadingZeros(+date, token.length);
  }
};
function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

// dist/_lib/format/longFormatters.js
var dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
var timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
var dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

// dist/_lib/protectedTokens.js
var dayOfYearTokenRE = /^D+$/;
var weekYearTokenRE = /^Y+$/;
var throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token))
    throw new RangeError(_message);
}
function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

// dist/format.js
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
  const defaultOptions2 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions2.firstWeekContainsDate ?? defaultOptions2.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  const originalDate = toDate(date, options?.in);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken)
      return part.value;
    const token = part.value;
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token) || !options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

// dist/fp/format.js
var format2 = convertToFP(format, 2);
// dist/formatDistance.js
function formatDistance2(laterDate, earlierDate, options) {
  const defaultOptions2 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions2.locale ?? enUS;
  const minutesInAlmostTwoDays = 2520;
  const comparison = compareAsc(laterDate, earlierDate);
  if (isNaN(comparison))
    throw new RangeError("Invalid time value");
  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison
  });
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, ...comparison > 0 ? [earlierDate, laterDate] : [laterDate, earlierDate]);
  const seconds = differenceInSeconds(earlierDate_, laterDate_);
  const offsetInSeconds = (getTimezoneOffsetInMilliseconds(earlierDate_) - getTimezoneOffsetInMilliseconds(laterDate_)) / 1000;
  const minutes = Math.round((seconds - offsetInSeconds) / 60);
  let months;
  if (minutes < 2) {
    if (options?.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance("halfAMinute", 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", minutes, localizeOptions);
      }
    }
  } else if (minutes < 45) {
    return locale.formatDistance("xMinutes", minutes, localizeOptions);
  } else if (minutes < 90) {
    return locale.formatDistance("aboutXHours", 1, localizeOptions);
  } else if (minutes < minutesInDay) {
    const hours = Math.round(minutes / 60);
    return locale.formatDistance("aboutXHours", hours, localizeOptions);
  } else if (minutes < minutesInAlmostTwoDays) {
    return locale.formatDistance("xDays", 1, localizeOptions);
  } else if (minutes < minutesInMonth) {
    const days = Math.round(minutes / minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);
  } else if (minutes < minutesInMonth * 2) {
    months = Math.round(minutes / minutesInMonth);
    return locale.formatDistance("aboutXMonths", months, localizeOptions);
  }
  months = differenceInMonths(earlierDate_, laterDate_);
  if (months < 12) {
    const nearestMonth = Math.round(minutes / minutesInMonth);
    return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
  } else {
    const monthsSinceStartOfYear = months % 12;
    const years = Math.trunc(months / 12);
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance("aboutXYears", years, localizeOptions);
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance("overXYears", years, localizeOptions);
    } else {
      return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
  }
}

// dist/fp/formatDistance.js
var formatDistance3 = convertToFP(formatDistance2, 2);
// dist/formatDistanceStrict.js
function formatDistanceStrict(laterDate, earlierDate, options) {
  const defaultOptions2 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions2.locale ?? enUS;
  const comparison = compareAsc(laterDate, earlierDate);
  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }
  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison
  });
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, ...comparison > 0 ? [earlierDate, laterDate] : [laterDate, earlierDate]);
  const roundingMethod = getRoundingMethod(options?.roundingMethod ?? "round");
  const milliseconds = earlierDate_.getTime() - laterDate_.getTime();
  const minutes = milliseconds / millisecondsInMinute;
  const timezoneOffset = getTimezoneOffsetInMilliseconds(earlierDate_) - getTimezoneOffsetInMilliseconds(laterDate_);
  const dstNormalizedMinutes = (milliseconds - timezoneOffset) / millisecondsInMinute;
  const defaultUnit = options?.unit;
  let unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < minutesInDay) {
      unit = "hour";
    } else if (dstNormalizedMinutes < minutesInMonth) {
      unit = "day";
    } else if (dstNormalizedMinutes < minutesInYear) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = defaultUnit;
  }
  if (unit === "second") {
    const seconds = roundingMethod(milliseconds / 1000);
    return locale.formatDistance("xSeconds", seconds, localizeOptions);
  } else if (unit === "minute") {
    const roundedMinutes = roundingMethod(minutes);
    return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
  } else if (unit === "hour") {
    const hours = roundingMethod(minutes / 60);
    return locale.formatDistance("xHours", hours, localizeOptions);
  } else if (unit === "day") {
    const days = roundingMethod(dstNormalizedMinutes / minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);
  } else if (unit === "month") {
    const months = roundingMethod(dstNormalizedMinutes / minutesInMonth);
    return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
  } else {
    const years = roundingMethod(dstNormalizedMinutes / minutesInYear);
    return locale.formatDistance("xYears", years, localizeOptions);
  }
}

// dist/fp/formatDistanceStrict.js
var formatDistanceStrict2 = convertToFP(formatDistanceStrict, 2);
// dist/fp/formatDistanceStrictWithOptions.js
var formatDistanceStrictWithOptions = convertToFP(formatDistanceStrict, 3);
// dist/fp/formatDistanceWithOptions.js
var formatDistanceWithOptions = convertToFP(formatDistance2, 3);
// dist/formatDuration.js
var defaultFormat = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];
function formatDuration(duration, options) {
  const defaultOptions2 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions2.locale ?? enUS;
  const format3 = options?.format ?? defaultFormat;
  const zero = options?.zero ?? false;
  const delimiter = options?.delimiter ?? " ";
  if (!locale.formatDistance) {
    return "";
  }
  const result = format3.reduce((acc, unit) => {
    const token = `x${unit.replace(/(^.)/, (m) => m.toUpperCase())}`;
    const value = duration[unit];
    if (value !== undefined && (zero || duration[unit])) {
      return acc.concat(locale.formatDistance(token, value));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}

// dist/fp/formatDuration.js
var formatDuration2 = convertToFP(formatDuration, 1);
// dist/fp/formatDurationWithOptions.js
var formatDurationWithOptions = convertToFP(formatDuration, 2);
// dist/formatISO.js
function formatISO(date, options) {
  const date_ = toDate(date, options?.in);
  if (isNaN(+date_)) {
    throw new RangeError("Invalid time value");
  }
  const format3 = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";
  let result = "";
  let tzOffset = "";
  const dateDelimiter = format3 === "extended" ? "-" : "";
  const timeDelimiter = format3 === "extended" ? ":" : "";
  if (representation !== "time") {
    const day = addLeadingZeros(date_.getDate(), 2);
    const month = addLeadingZeros(date_.getMonth() + 1, 2);
    const year = addLeadingZeros(date_.getFullYear(), 4);
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }
  if (representation !== "date") {
    const offset = date_.getTimezoneOffset();
    if (offset !== 0) {
      const absoluteOffset = Math.abs(offset);
      const hourOffset = addLeadingZeros(Math.trunc(absoluteOffset / 60), 2);
      const minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
      const sign = offset < 0 ? "+" : "-";
      tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
    } else {
      tzOffset = "Z";
    }
    const hour = addLeadingZeros(date_.getHours(), 2);
    const minute = addLeadingZeros(date_.getMinutes(), 2);
    const second = addLeadingZeros(date_.getSeconds(), 2);
    const separator = result === "" ? "" : "T";
    const time = [hour, minute, second].join(timeDelimiter);
    result = `${result}${separator}${time}${tzOffset}`;
  }
  return result;
}

// dist/fp/formatISO.js
var formatISO2 = convertToFP(formatISO, 1);
// dist/formatISO9075.js
function formatISO9075(date, options) {
  const date_ = toDate(date, options?.in);
  if (!isValid(date_)) {
    throw new RangeError("Invalid time value");
  }
  const format3 = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";
  let result = "";
  const dateDelimiter = format3 === "extended" ? "-" : "";
  const timeDelimiter = format3 === "extended" ? ":" : "";
  if (representation !== "time") {
    const day = addLeadingZeros(date_.getDate(), 2);
    const month = addLeadingZeros(date_.getMonth() + 1, 2);
    const year = addLeadingZeros(date_.getFullYear(), 4);
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }
  if (representation !== "date") {
    const hour = addLeadingZeros(date_.getHours(), 2);
    const minute = addLeadingZeros(date_.getMinutes(), 2);
    const second = addLeadingZeros(date_.getSeconds(), 2);
    const separator = result === "" ? "" : " ";
    result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
  }
  return result;
}

// dist/fp/formatISO9075.js
var formatISO90752 = convertToFP(formatISO9075, 1);
// dist/fp/formatISO9075WithOptions.js
var formatISO9075WithOptions = convertToFP(formatISO9075, 2);
// dist/formatISODuration.js
function formatISODuration(duration) {
  const {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

// dist/fp/formatISODuration.js
var formatISODuration2 = convertToFP(formatISODuration, 1);
// dist/fp/formatISOWithOptions.js
var formatISOWithOptions = convertToFP(formatISO, 2);
// dist/formatRFC3339.js
function formatRFC3339(date, options) {
  const date_ = toDate(date, options?.in);
  if (!isValid(date_)) {
    throw new RangeError("Invalid time value");
  }
  const fractionDigits = options?.fractionDigits ?? 0;
  const day = addLeadingZeros(date_.getDate(), 2);
  const month = addLeadingZeros(date_.getMonth() + 1, 2);
  const year = date_.getFullYear();
  const hour = addLeadingZeros(date_.getHours(), 2);
  const minute = addLeadingZeros(date_.getMinutes(), 2);
  const second = addLeadingZeros(date_.getSeconds(), 2);
  let fractionalSecond = "";
  if (fractionDigits > 0) {
    const milliseconds = date_.getMilliseconds();
    const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
    fractionalSecond = "." + addLeadingZeros(fractionalSeconds, fractionDigits);
  }
  let offset = "";
  const tzOffset = date_.getTimezoneOffset();
  if (tzOffset !== 0) {
    const absoluteOffset = Math.abs(tzOffset);
    const hourOffset = addLeadingZeros(Math.trunc(absoluteOffset / 60), 2);
    const minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
    const sign = tzOffset < 0 ? "+" : "-";
    offset = `${sign}${hourOffset}:${minuteOffset}`;
  } else {
    offset = "Z";
  }
  return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

// dist/fp/formatRFC3339.js
var formatRFC33392 = convertToFP(formatRFC3339, 1);
// dist/fp/formatRFC3339WithOptions.js
var formatRFC3339WithOptions = convertToFP(formatRFC3339, 2);
// dist/formatRFC7231.js
var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function formatRFC7231(date) {
  const _date = toDate(date);
  if (!isValid(_date)) {
    throw new RangeError("Invalid time value");
  }
  const dayName = days[_date.getUTCDay()];
  const dayOfMonth = addLeadingZeros(_date.getUTCDate(), 2);
  const monthName = months[_date.getUTCMonth()];
  const year = _date.getUTCFullYear();
  const hour = addLeadingZeros(_date.getUTCHours(), 2);
  const minute = addLeadingZeros(_date.getUTCMinutes(), 2);
  const second = addLeadingZeros(_date.getUTCSeconds(), 2);
  return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

// dist/fp/formatRFC7231.js
var formatRFC72312 = convertToFP(formatRFC7231, 1);
// dist/formatRelative.js
function formatRelative2(date, baseDate, options) {
  const [date_, baseDate_] = normalizeDates(options?.in, date, baseDate);
  const defaultOptions2 = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions2.locale ?? enUS;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  const diff = differenceInCalendarDays(date_, baseDate_);
  if (isNaN(diff)) {
    throw new RangeError("Invalid time value");
  }
  let token;
  if (diff < -6) {
    token = "other";
  } else if (diff < -1) {
    token = "lastWeek";
  } else if (diff < 0) {
    token = "yesterday";
  } else if (diff < 1) {
    token = "today";
  } else if (diff < 2) {
    token = "tomorrow";
  } else if (diff < 7) {
    token = "nextWeek";
  } else {
    token = "other";
  }
  const formatStr = locale.formatRelative(token, date_, baseDate_, {
    locale,
    weekStartsOn
  });
  return format(date_, formatStr, { locale, weekStartsOn });
}

// dist/fp/formatRelative.js
var formatRelative3 = convertToFP(formatRelative2, 2);
// dist/fp/formatRelativeWithOptions.js
var formatRelativeWithOptions = convertToFP(formatRelative2, 3);
// dist/fp/formatWithOptions.js
var formatWithOptions = convertToFP(format, 3);
// dist/fromUnixTime.js
function fromUnixTime(unixTime, options) {
  return toDate(unixTime * 1000, options?.in);
}

// dist/fp/fromUnixTime.js
var fromUnixTime2 = convertToFP(fromUnixTime, 1);
// dist/fp/fromUnixTimeWithOptions.js
var fromUnixTimeWithOptions = convertToFP(fromUnixTime, 2);
// dist/getDate.js
function getDate(date, options) {
  return toDate(date, options?.in).getDate();
}

// dist/fp/getDate.js
var getDate2 = convertToFP(getDate, 1);
// dist/fp/getDateWithOptions.js
var getDateWithOptions = convertToFP(getDate, 2);
// dist/getDay.js
function getDay(date, options) {
  return toDate(date, options?.in).getDay();
}

// dist/fp/getDay.js
var getDay2 = convertToFP(getDay, 1);
// dist/fp/getDayOfYear.js
var getDayOfYear2 = convertToFP(getDayOfYear, 1);
// dist/fp/getDayOfYearWithOptions.js
var getDayOfYearWithOptions = convertToFP(getDayOfYear, 2);
// dist/fp/getDayWithOptions.js
var getDayWithOptions = convertToFP(getDay, 2);
// dist/getDaysInMonth.js
function getDaysInMonth(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(_date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

// dist/fp/getDaysInMonth.js
var getDaysInMonth2 = convertToFP(getDaysInMonth, 1);
// dist/fp/getDaysInMonthWithOptions.js
var getDaysInMonthWithOptions = convertToFP(getDaysInMonth, 2);
// dist/isLeapYear.js
function isLeapYear(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

// dist/getDaysInYear.js
function getDaysInYear(date, options) {
  const _date = toDate(date, options?.in);
  if (Number.isNaN(+_date))
    return NaN;
  return isLeapYear(_date) ? 366 : 365;
}

// dist/fp/getDaysInYear.js
var getDaysInYear2 = convertToFP(getDaysInYear, 1);
// dist/fp/getDaysInYearWithOptions.js
var getDaysInYearWithOptions = convertToFP(getDaysInYear, 2);
// dist/getDecade.js
function getDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  return decade;
}

// dist/fp/getDecade.js
var getDecade2 = convertToFP(getDecade, 1);
// dist/fp/getDecadeWithOptions.js
var getDecadeWithOptions = convertToFP(getDecade, 2);
// dist/getHours.js
function getHours(date, options) {
  return toDate(date, options?.in).getHours();
}

// dist/fp/getHours.js
var getHours2 = convertToFP(getHours, 1);
// dist/fp/getHoursWithOptions.js
var getHoursWithOptions = convertToFP(getHours, 2);
// dist/getISODay.js
function getISODay(date, options) {
  const day = toDate(date, options?.in).getDay();
  return day === 0 ? 7 : day;
}

// dist/fp/getISODay.js
var getISODay2 = convertToFP(getISODay, 1);
// dist/fp/getISODayWithOptions.js
var getISODayWithOptions = convertToFP(getISODay, 2);
// dist/fp/getISOWeek.js
var getISOWeek2 = convertToFP(getISOWeek, 1);
// dist/fp/getISOWeekWithOptions.js
var getISOWeekWithOptions = convertToFP(getISOWeek, 2);
// dist/fp/getISOWeekYear.js
var getISOWeekYear2 = convertToFP(getISOWeekYear, 1);
// dist/fp/getISOWeekYearWithOptions.js
var getISOWeekYearWithOptions = convertToFP(getISOWeekYear, 2);
// dist/getISOWeeksInYear.js
function getISOWeeksInYear(date, options) {
  const thisYear = startOfISOWeekYear(date, options);
  const nextYear = startOfISOWeekYear(addWeeks(thisYear, 60));
  const diff = +nextYear - +thisYear;
  return Math.round(diff / millisecondsInWeek);
}

// dist/fp/getISOWeeksInYear.js
var getISOWeeksInYear2 = convertToFP(getISOWeeksInYear, 1);
// dist/fp/getISOWeeksInYearWithOptions.js
var getISOWeeksInYearWithOptions = convertToFP(getISOWeeksInYear, 2);
// dist/getMilliseconds.js
function getMilliseconds(date) {
  return toDate(date).getMilliseconds();
}

// dist/fp/getMilliseconds.js
var getMilliseconds2 = convertToFP(getMilliseconds, 1);
// dist/getMinutes.js
function getMinutes(date, options) {
  return toDate(date, options?.in).getMinutes();
}

// dist/fp/getMinutes.js
var getMinutes2 = convertToFP(getMinutes, 1);
// dist/fp/getMinutesWithOptions.js
var getMinutesWithOptions = convertToFP(getMinutes, 2);
// dist/getMonth.js
function getMonth(date, options) {
  return toDate(date, options?.in).getMonth();
}

// dist/fp/getMonth.js
var getMonth2 = convertToFP(getMonth, 1);
// dist/fp/getMonthWithOptions.js
var getMonthWithOptions = convertToFP(getMonth, 2);
// dist/getOverlappingDaysInIntervals.js
function getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
  const [leftStart, leftEnd] = [
    +toDate(intervalLeft.start),
    +toDate(intervalLeft.end)
  ].sort((a, b) => a - b);
  const [rightStart, rightEnd] = [
    +toDate(intervalRight.start),
    +toDate(intervalRight.end)
  ].sort((a, b) => a - b);
  const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
  if (!isOverlapping)
    return 0;
  const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
  const left = overlapLeft - getTimezoneOffsetInMilliseconds(overlapLeft);
  const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
  const right = overlapRight - getTimezoneOffsetInMilliseconds(overlapRight);
  return Math.ceil((right - left) / millisecondsInDay);
}

// dist/fp/getOverlappingDaysInIntervals.js
var getOverlappingDaysInIntervals2 = convertToFP(getOverlappingDaysInIntervals, 2);
// dist/fp/getQuarter.js
var getQuarter2 = convertToFP(getQuarter, 1);
// dist/fp/getQuarterWithOptions.js
var getQuarterWithOptions = convertToFP(getQuarter, 2);
// dist/getSeconds.js
function getSeconds(date) {
  return toDate(date).getSeconds();
}

// dist/fp/getSeconds.js
var getSeconds2 = convertToFP(getSeconds, 1);
// dist/getTime.js
function getTime(date) {
  return +toDate(date);
}

// dist/fp/getTime.js
var getTime2 = convertToFP(getTime, 1);
// dist/getUnixTime.js
function getUnixTime(date) {
  return Math.trunc(+toDate(date) / 1000);
}

// dist/fp/getUnixTime.js
var getUnixTime2 = convertToFP(getUnixTime, 1);
// dist/fp/getWeek.js
var getWeek2 = convertToFP(getWeek, 1);
// dist/getWeekOfMonth.js
function getWeekOfMonth(date, options) {
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  const currentDayOfMonth = getDate(toDate(date, options?.in));
  if (isNaN(currentDayOfMonth))
    return NaN;
  const startWeekDay = getDay(startOfMonth(date, options));
  let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0)
    lastDayOfFirstWeek += 7;
  const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

// dist/fp/getWeekOfMonth.js
var getWeekOfMonth2 = convertToFP(getWeekOfMonth, 1);
// dist/fp/getWeekOfMonthWithOptions.js
var getWeekOfMonthWithOptions = convertToFP(getWeekOfMonth, 2);
// dist/fp/getWeekWithOptions.js
var getWeekWithOptions = convertToFP(getWeek, 2);
// dist/fp/getWeekYear.js
var getWeekYear2 = convertToFP(getWeekYear, 1);
// dist/fp/getWeekYearWithOptions.js
var getWeekYearWithOptions = convertToFP(getWeekYear, 2);
// dist/lastDayOfMonth.js
function lastDayOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(0, 0, 0, 0);
  return toDate(_date, options?.in);
}

// dist/getWeeksInMonth.js
function getWeeksInMonth(date, options) {
  const contextDate = toDate(date, options?.in);
  return differenceInCalendarWeeks(lastDayOfMonth(contextDate, options), startOfMonth(contextDate, options), options) + 1;
}

// dist/fp/getWeeksInMonth.js
var getWeeksInMonth2 = convertToFP(getWeeksInMonth, 1);
// dist/fp/getWeeksInMonthWithOptions.js
var getWeeksInMonthWithOptions = convertToFP(getWeeksInMonth, 2);
// dist/getYear.js
function getYear(date, options) {
  return toDate(date, options?.in).getFullYear();
}

// dist/fp/getYear.js
var getYear2 = convertToFP(getYear, 1);
// dist/fp/getYearWithOptions.js
var getYearWithOptions = convertToFP(getYear, 2);
// dist/hoursToMilliseconds.js
function hoursToMilliseconds(hours) {
  return Math.trunc(hours * millisecondsInHour);
}

// dist/fp/hoursToMilliseconds.js
var hoursToMilliseconds2 = convertToFP(hoursToMilliseconds, 1);
// dist/hoursToMinutes.js
function hoursToMinutes(hours) {
  return Math.trunc(hours * minutesInHour);
}

// dist/fp/hoursToMinutes.js
var hoursToMinutes2 = convertToFP(hoursToMinutes, 1);
// dist/hoursToSeconds.js
function hoursToSeconds(hours) {
  return Math.trunc(hours * secondsInHour);
}

// dist/fp/hoursToSeconds.js
var hoursToSeconds2 = convertToFP(hoursToSeconds, 1);
// dist/interval.js
function interval(start, end, options) {
  const [_start, _end] = normalizeDates(options?.in, start, end);
  if (isNaN(+_start))
    throw new TypeError("Start date is invalid");
  if (isNaN(+_end))
    throw new TypeError("End date is invalid");
  if (options?.assertPositive && +_start > +_end)
    throw new TypeError("End date must be after start date");
  return { start: _start, end: _end };
}

// dist/fp/interval.js
var interval2 = convertToFP(interval, 2);
// dist/intervalToDuration.js
function intervalToDuration(interval3, options) {
  const { start, end } = normalizeInterval(options?.in, interval3);
  const duration = {};
  const years = differenceInYears(end, start);
  if (years)
    duration.years = years;
  const remainingMonths = add(start, { years: duration.years });
  const months2 = differenceInMonths(end, remainingMonths);
  if (months2)
    duration.months = months2;
  const remainingDays = add(remainingMonths, { months: duration.months });
  const days2 = differenceInDays(end, remainingDays);
  if (days2)
    duration.days = days2;
  const remainingHours = add(remainingDays, { days: duration.days });
  const hours = differenceInHours(end, remainingHours);
  if (hours)
    duration.hours = hours;
  const remainingMinutes = add(remainingHours, { hours: duration.hours });
  const minutes = differenceInMinutes(end, remainingMinutes);
  if (minutes)
    duration.minutes = minutes;
  const remainingSeconds = add(remainingMinutes, { minutes: duration.minutes });
  const seconds = differenceInSeconds(end, remainingSeconds);
  if (seconds)
    duration.seconds = seconds;
  return duration;
}

// dist/fp/intervalToDuration.js
var intervalToDuration2 = convertToFP(intervalToDuration, 1);
// dist/fp/intervalToDurationWithOptions.js
var intervalToDurationWithOptions = convertToFP(intervalToDuration, 2);
// dist/fp/intervalWithOptions.js
var intervalWithOptions = convertToFP(interval, 3);
// dist/intlFormat.js
function intlFormat(date, formatOrLocale, localeOptions) {
  let formatOptions;
  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }
  return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format(toDate(date));
}
function isFormatOptions(opts) {
  return opts !== undefined && !("locale" in opts);
}

// dist/fp/intlFormat.js
var intlFormat2 = convertToFP(intlFormat, 3);
// dist/intlFormatDistance.js
function intlFormatDistance(laterDate, earlierDate, options) {
  let value = 0;
  let unit;
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  if (!options?.unit) {
    const diffInSeconds = differenceInSeconds(laterDate_, earlierDate_);
    if (Math.abs(diffInSeconds) < secondsInMinute) {
      value = differenceInSeconds(laterDate_, earlierDate_);
      unit = "second";
    } else if (Math.abs(diffInSeconds) < secondsInHour) {
      value = differenceInMinutes(laterDate_, earlierDate_);
      unit = "minute";
    } else if (Math.abs(diffInSeconds) < secondsInDay && Math.abs(differenceInCalendarDays(laterDate_, earlierDate_)) < 1) {
      value = differenceInHours(laterDate_, earlierDate_);
      unit = "hour";
    } else if (Math.abs(diffInSeconds) < secondsInWeek && (value = differenceInCalendarDays(laterDate_, earlierDate_)) && Math.abs(value) < 7) {
      unit = "day";
    } else if (Math.abs(diffInSeconds) < secondsInMonth) {
      value = differenceInCalendarWeeks(laterDate_, earlierDate_);
      unit = "week";
    } else if (Math.abs(diffInSeconds) < secondsInQuarter) {
      value = differenceInCalendarMonths(laterDate_, earlierDate_);
      unit = "month";
    } else if (Math.abs(diffInSeconds) < secondsInYear) {
      if (differenceInCalendarQuarters(laterDate_, earlierDate_) < 4) {
        value = differenceInCalendarQuarters(laterDate_, earlierDate_);
        unit = "quarter";
      } else {
        value = differenceInCalendarYears(laterDate_, earlierDate_);
        unit = "year";
      }
    } else {
      value = differenceInCalendarYears(laterDate_, earlierDate_);
      unit = "year";
    }
  } else {
    unit = options?.unit;
    if (unit === "second") {
      value = differenceInSeconds(laterDate_, earlierDate_);
    } else if (unit === "minute") {
      value = differenceInMinutes(laterDate_, earlierDate_);
    } else if (unit === "hour") {
      value = differenceInHours(laterDate_, earlierDate_);
    } else if (unit === "day") {
      value = differenceInCalendarDays(laterDate_, earlierDate_);
    } else if (unit === "week") {
      value = differenceInCalendarWeeks(laterDate_, earlierDate_);
    } else if (unit === "month") {
      value = differenceInCalendarMonths(laterDate_, earlierDate_);
    } else if (unit === "quarter") {
      value = differenceInCalendarQuarters(laterDate_, earlierDate_);
    } else if (unit === "year") {
      value = differenceInCalendarYears(laterDate_, earlierDate_);
    }
  }
  const rtf = new Intl.RelativeTimeFormat(options?.locale, {
    numeric: "auto",
    ...options
  });
  return rtf.format(value, unit);
}

// dist/fp/intlFormatDistance.js
var intlFormatDistance2 = convertToFP(intlFormatDistance, 2);
// dist/fp/intlFormatDistanceWithOptions.js
var intlFormatDistanceWithOptions = convertToFP(intlFormatDistance, 3);
// dist/isAfter.js
function isAfter(date, dateToCompare) {
  return +toDate(date) > +toDate(dateToCompare);
}

// dist/fp/isAfter.js
var isAfter2 = convertToFP(isAfter, 2);
// dist/isBefore.js
function isBefore(date, dateToCompare) {
  return +toDate(date) < +toDate(dateToCompare);
}

// dist/fp/isBefore.js
var isBefore2 = convertToFP(isBefore, 2);
// dist/fp/isDate.js
var isDate2 = convertToFP(isDate, 1);
// dist/isEqual.js
function isEqual(leftDate, rightDate) {
  return +toDate(leftDate) === +toDate(rightDate);
}

// dist/fp/isEqual.js
var isEqual2 = convertToFP(isEqual, 2);
// dist/isExists.js
function isExists(year, month, day) {
  const date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

// dist/fp/isExists.js
var isExists2 = convertToFP(isExists, 3);
// dist/isFirstDayOfMonth.js
function isFirstDayOfMonth(date, options) {
  return toDate(date, options?.in).getDate() === 1;
}

// dist/fp/isFirstDayOfMonth.js
var isFirstDayOfMonth2 = convertToFP(isFirstDayOfMonth, 1);
// dist/fp/isFirstDayOfMonthWithOptions.js
var isFirstDayOfMonthWithOptions = convertToFP(isFirstDayOfMonth, 2);
// dist/isFriday.js
function isFriday(date, options) {
  return toDate(date, options?.in).getDay() === 5;
}

// dist/fp/isFriday.js
var isFriday2 = convertToFP(isFriday, 1);
// dist/fp/isFridayWithOptions.js
var isFridayWithOptions = convertToFP(isFriday, 2);
// dist/fp/isLastDayOfMonth.js
var isLastDayOfMonth2 = convertToFP(isLastDayOfMonth, 1);
// dist/fp/isLastDayOfMonthWithOptions.js
var isLastDayOfMonthWithOptions = convertToFP(isLastDayOfMonth, 2);
// dist/fp/isLeapYear.js
var isLeapYear2 = convertToFP(isLeapYear, 1);
// dist/fp/isLeapYearWithOptions.js
var isLeapYearWithOptions = convertToFP(isLeapYear, 2);
// dist/getDefaultOptions.js
function getDefaultOptions2() {
  return Object.assign({}, getDefaultOptions());
}

// dist/transpose.js
function transpose(date, constructor) {
  const date_ = isConstructor(constructor) ? new constructor(0) : constructFrom(constructor, 0);
  date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
  date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  return date_;
}
function isConstructor(constructor) {
  return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}

// dist/parse/_lib/Setter.js
var TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;
  validate(_utcDate, _options) {
    return true;
  }
}

class ValueSetter extends Setter {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }
  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}

class DateTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  constructor(context, reference) {
    super();
    this.context = context || ((date) => constructFrom(reference, date));
  }
  set(date, flags) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, transpose(date, this.context));
  }
}

// dist/parse/_lib/Parser.js
class Parser {
  run(dateString, token, match2, options) {
    const result = this.parse(dateString, token, match2, options);
    if (!result) {
      return null;
    }
    return {
      setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
      rest: result.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
}

// dist/parse/_lib/parsers/EraParser.js
class EraParser extends Parser {
  priority = 140;
  parse(dateString, token, match2) {
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return match2.era(dateString, { width: "abbreviated" }) || match2.era(dateString, { width: "narrow" });
      case "GGGGG":
        return match2.era(dateString, { width: "narrow" });
      case "GGGG":
      default:
        return match2.era(dateString, { width: "wide" }) || match2.era(dateString, { width: "abbreviated" }) || match2.era(dateString, { width: "narrow" });
    }
  }
  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}

// dist/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

// dist/parse/_lib/utils.js
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

// dist/parse/_lib/parsers/YearParser.js
class YearParser extends Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(dateString, token, match2) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy"
    });
    switch (token) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value) {
    const currentYear = date.getFullYear();
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// dist/parse/_lib/parsers/LocalWeekYearParser.js
class LocalWeekYearParser extends Parser {
  priority = 130;
  parse(dateString, token, match2) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY"
    });
    switch (token) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value, options) {
    const currentYear = getWeekYear(date, options);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
      date.setHours(0, 0, 0, 0);
      return startOfWeek(date, options);
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek(date, options);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/ISOWeekYearParser.js
class ISOWeekYearParser extends Parser {
  priority = 130;
  parse(dateString, token) {
    if (token === "R") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/ExtendedYearParser.js
class ExtendedYearParser extends Parser {
  priority = 130;
  parse(dateString, token) {
    if (token === "u") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}

// dist/parse/_lib/parsers/QuarterParser.js
class QuarterParser extends Parser {
  priority = 120;
  parse(dateString, token, match2) {
    switch (token) {
      case "Q":
      case "QQ":
        return parseNDigits(token.length, dateString);
      case "Qo":
        return match2.ordinalNumber(dateString, { unit: "quarter" });
      case "QQQ":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/StandAloneQuarterParser.js
class StandAloneQuarterParser extends Parser {
  priority = 120;
  parse(dateString, token, match2) {
    switch (token) {
      case "q":
      case "qq":
        return parseNDigits(token.length, dateString);
      case "qo":
        return match2.ordinalNumber(dateString, { unit: "quarter" });
      case "qqq":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/MonthParser.js
class MonthParser extends Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(dateString, token, match2) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      case "M":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Mo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "MMM":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return match2.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return match2.month(dateString, { width: "wide", context: "formatting" }) || match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// dist/parse/_lib/parsers/StandAloneMonthParser.js
class StandAloneMonthParser extends Parser {
  priority = 110;
  parse(dateString, token, match2) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      case "L":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Lo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "LLL":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return match2.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return match2.month(dateString, { width: "wide", context: "standalone" }) || match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/setWeek.js
function setWeek(date, week, options) {
  const date_ = toDate(date, options?.in);
  const diff = getWeek(date_, options) - week;
  date_.setDate(date_.getDate() - diff * 7);
  return toDate(date_, options?.in);
}

// dist/parse/_lib/parsers/LocalWeekParser.js
class LocalWeekParser extends Parser {
  priority = 100;
  parse(dateString, token, match2) {
    switch (token) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match2.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value, options) {
    return startOfWeek(setWeek(date, value, options), options);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}

// dist/setISOWeek.js
function setISOWeek(date, week, options) {
  const _date = toDate(date, options?.in);
  const diff = getISOWeek(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

// dist/parse/_lib/parsers/ISOWeekParser.js
class ISOWeekParser extends Parser {
  priority = 100;
  parse(dateString, token, match2) {
    switch (token) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match2.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value) {
    return startOfISOWeek(setISOWeek(date, value));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/DateParser.js
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];

class DateParser extends Parser {
  priority = 90;
  subPriority = 1;
  parse(dateString, token, match2) {
    switch (token) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match2.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear3 = isLeapYearIndex(year);
    const month = date.getMonth();
    if (isLeapYear3) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }
  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/DayOfYearParser.js
class DayOfYearParser extends Parser {
  priority = 90;
  subpriority = 1;
  parse(dateString, token, match2) {
    switch (token) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match2.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear3 = isLeapYearIndex(year);
    if (isLeapYear3) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }
  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/setDay.js
function setDay(date, day, options) {
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  const date_ = toDate(date, options?.in);
  const currentDay = date_.getDay();
  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;
  const delta = 7 - weekStartsOn;
  const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(date_, diff, options);
}

// dist/parse/_lib/parsers/DayParser.js
class DayParser extends Parser {
  priority = 90;
  parse(dateString, token, match2) {
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return match2.day(dateString, { width: "wide", context: "formatting" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}

// dist/parse/_lib/parsers/LocalDayParser.js
class LocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match2, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "e":
      case "ee":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "eo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "eee":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "eeeee":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return match2.day(dateString, { width: "wide", context: "formatting" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/StandAloneLocalDayParser.js
class StandAloneLocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match2, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "c":
      case "cc":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "co":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "ccc":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
      case "ccccc":
        return match2.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return match2.day(dateString, { width: "wide", context: "standalone" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}

// dist/setISODay.js
function setISODay(date, day, options) {
  const date_ = toDate(date, options?.in);
  const currentDay = getISODay(date_, options);
  const diff = day - currentDay;
  return addDays(date_, diff, options);
}

// dist/parse/_lib/parsers/ISODayParser.js
class ISODayParser extends Parser {
  priority = 90;
  parse(dateString, token, match2) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };
    switch (token) {
      case "i":
      case "ii":
        return parseNDigits(token.length, dateString);
      case "io":
        return match2.ordinalNumber(dateString, { unit: "day" });
      case "iii":
        return mapValue(match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiii":
        return mapValue(match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiiii":
        return mapValue(match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiii":
      default:
        return mapValue(match2.day(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 7;
  }
  set(date, _flags, value) {
    date = setISODay(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}

// dist/parse/_lib/parsers/AMPMParser.js
class AMPMParser extends Parser {
  priority = 80;
  parse(dateString, token, match2) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}

// dist/parse/_lib/parsers/AMPMMidnightParser.js
class AMPMMidnightParser extends Parser {
  priority = 80;
  parse(dateString, token, match2) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}

// dist/parse/_lib/parsers/DayPeriodParser.js
class DayPeriodParser extends Parser {
  priority = 80;
  parse(dateString, token, match2) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}

// dist/parse/_lib/parsers/Hour1to12Parser.js
class Hour1to12Parser extends Parser {
  priority = 70;
  parse(dateString, token, match2) {
    switch (token) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 12;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}

// dist/parse/_lib/parsers/Hour0to23Parser.js
class Hour0to23Parser extends Parser {
  priority = 70;
  parse(dateString, token, match2) {
    switch (token) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 23;
  }
  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}

// dist/parse/_lib/parsers/Hour0To11Parser.js
class Hour0To11Parser extends Parser {
  priority = 70;
  parse(dateString, token, match2) {
    switch (token) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}

// dist/parse/_lib/parsers/Hour1To24Parser.js
class Hour1To24Parser extends Parser {
  priority = 70;
  parse(dateString, token, match2) {
    switch (token) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 24;
  }
  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}

// dist/parse/_lib/parsers/MinuteParser.js
class MinuteParser extends Parser {
  priority = 60;
  parse(dateString, token, match2) {
    switch (token) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match2.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// dist/parse/_lib/parsers/SecondParser.js
class SecondParser extends Parser {
  priority = 50;
  parse(dateString, token, match2) {
    switch (token) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match2.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// dist/parse/_lib/parsers/FractionOfSecondParser.js
class FractionOfSecondParser extends Parser {
  priority = 30;
  parse(dateString, token) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token.length + 3));
    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }
  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }
  incompatibleTokens = ["t", "T"];
}

// dist/parse/_lib/parsers/ISOTimezoneWithZParser.js
class ISOTimezoneWithZParser extends Parser {
  priority = 10;
  parse(dateString, token) {
    switch (token) {
      case "X":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "XXXXX":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, date.getTime() - getTimezoneOffsetInMilliseconds(date) - value);
  }
  incompatibleTokens = ["t", "T", "x"];
}

// dist/parse/_lib/parsers/ISOTimezoneParser.js
class ISOTimezoneParser extends Parser {
  priority = 10;
  parse(dateString, token) {
    switch (token) {
      case "x":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "xxxxx":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet)
      return date;
    return constructFrom(date, date.getTime() - getTimezoneOffsetInMilliseconds(date) - value);
  }
  incompatibleTokens = ["t", "T", "X"];
}

// dist/parse/_lib/parsers/TimestampSecondsParser.js
class TimestampSecondsParser extends Parser {
  priority = 40;
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value * 1000), { timestampIsSet: true }];
  }
  incompatibleTokens = "*";
}

// dist/parse/_lib/parsers/TimestampMillisecondsParser.js
class TimestampMillisecondsParser extends Parser {
  priority = 20;
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value), { timestampIsSet: true }];
  }
  incompatibleTokens = "*";
}

// dist/parse/_lib/parsers.js
var parsers = {
  G: new EraParser,
  y: new YearParser,
  Y: new LocalWeekYearParser,
  R: new ISOWeekYearParser,
  u: new ExtendedYearParser,
  Q: new QuarterParser,
  q: new StandAloneQuarterParser,
  M: new MonthParser,
  L: new StandAloneMonthParser,
  w: new LocalWeekParser,
  I: new ISOWeekParser,
  d: new DateParser,
  D: new DayOfYearParser,
  E: new DayParser,
  e: new LocalDayParser,
  c: new StandAloneLocalDayParser,
  i: new ISODayParser,
  a: new AMPMParser,
  b: new AMPMMidnightParser,
  B: new DayPeriodParser,
  h: new Hour1to12Parser,
  H: new Hour0to23Parser,
  K: new Hour0To11Parser,
  k: new Hour1To24Parser,
  m: new MinuteParser,
  s: new SecondParser,
  S: new FractionOfSecondParser,
  X: new ISOTimezoneWithZParser,
  x: new ISOTimezoneParser,
  t: new TimestampSecondsParser,
  T: new TimestampMillisecondsParser
};

// dist/parse.js
var formattingTokensRegExp2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp2 = /^'([^]*?)'?$/;
var doubleQuoteRegExp2 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp2 = /[a-zA-Z]/;
function parse(dateStr, formatStr, referenceDate, options) {
  const invalidDate = () => constructFrom(options?.in || referenceDate, NaN);
  const defaultOptions2 = getDefaultOptions2();
  const locale = options?.locale ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions2.firstWeekContainsDate ?? defaultOptions2.locale?.options?.firstWeekContainsDate ?? 1;
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  if (!formatStr)
    return dateStr ? invalidDate() : toDate(referenceDate, options?.in);
  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  const setters = [new DateTimezoneSetter(options?.in, referenceDate)];
  const tokens = formatStr.match(longFormattingTokensRegExp2).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp2);
  const usedTokens = [];
  for (let token of tokens) {
    if (!options?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    if (!options?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    const firstCharacter = token[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find((usedToken) => incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
        if (incompatibleToken) {
          throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
      }
      usedTokens.push({ token: firstCharacter, fullToken: token });
      const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
      if (!parseResult) {
        return invalidDate();
      }
      setters.push(parseResult.setter);
      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp2)) {
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
      }
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString2(token);
      }
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return invalidDate();
      }
    }
  }
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return invalidDate();
  }
  const uniquePrioritySetters = setters.map((setter) => setter.priority).sort((a, b) => b - a).filter((priority, index, array) => array.indexOf(priority) === index).map((priority) => setters.filter((setter) => setter.priority === priority).sort((a, b) => b.subPriority - a.subPriority)).map((setterArray) => setterArray[0]);
  let date = toDate(referenceDate, options?.in);
  if (isNaN(+date))
    return invalidDate();
  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return invalidDate();
    }
    const result = setter.set(date, flags, subFnOptions);
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
    } else {
      date = result;
    }
  }
  return date;
}
function cleanEscapedString2(input) {
  return input.match(escapedStringRegExp2)[1].replace(doubleQuoteRegExp2, "'");
}

// dist/isMatch.js
function isMatch(dateStr, formatStr, options) {
  return isValid(parse(dateStr, formatStr, new Date, options));
}

// dist/fp/isMatch.js
var isMatch2 = convertToFP(isMatch, 2);
// dist/fp/isMatchWithOptions.js
var isMatchWithOptions = convertToFP(isMatch, 3);
// dist/isMonday.js
function isMonday(date, options) {
  return toDate(date, options?.in).getDay() === 1;
}

// dist/fp/isMonday.js
var isMonday2 = convertToFP(isMonday, 1);
// dist/fp/isMondayWithOptions.js
var isMondayWithOptions = convertToFP(isMonday, 2);
// dist/fp/isSameDay.js
var isSameDay2 = convertToFP(isSameDay, 2);
// dist/fp/isSameDayWithOptions.js
var isSameDayWithOptions = convertToFP(isSameDay, 3);
// dist/startOfHour.js
function startOfHour(date, options) {
  const _date = toDate(date, options?.in);
  _date.setMinutes(0, 0, 0);
  return _date;
}

// dist/isSameHour.js
function isSameHour(dateLeft, dateRight, options) {
  const [dateLeft_, dateRight_] = normalizeDates(options?.in, dateLeft, dateRight);
  return +startOfHour(dateLeft_) === +startOfHour(dateRight_);
}

// dist/fp/isSameHour.js
var isSameHour2 = convertToFP(isSameHour, 2);
// dist/fp/isSameHourWithOptions.js
var isSameHourWithOptions = convertToFP(isSameHour, 3);
// dist/isSameWeek.js
function isSameWeek(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfWeek(laterDate_, options) === +startOfWeek(earlierDate_, options);
}

// dist/isSameISOWeek.js
function isSameISOWeek(laterDate, earlierDate, options) {
  return isSameWeek(laterDate, earlierDate, { ...options, weekStartsOn: 1 });
}

// dist/fp/isSameISOWeek.js
var isSameISOWeek2 = convertToFP(isSameISOWeek, 2);
// dist/fp/isSameISOWeekWithOptions.js
var isSameISOWeekWithOptions = convertToFP(isSameISOWeek, 3);
// dist/isSameISOWeekYear.js
function isSameISOWeekYear(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfISOWeekYear(laterDate_) === +startOfISOWeekYear(earlierDate_);
}

// dist/fp/isSameISOWeekYear.js
var isSameISOWeekYear2 = convertToFP(isSameISOWeekYear, 2);
// dist/fp/isSameISOWeekYearWithOptions.js
var isSameISOWeekYearWithOptions = convertToFP(isSameISOWeekYear, 3);
// dist/startOfMinute.js
function startOfMinute(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setSeconds(0, 0);
  return date_;
}

// dist/isSameMinute.js
function isSameMinute(laterDate, earlierDate) {
  return +startOfMinute(laterDate) === +startOfMinute(earlierDate);
}

// dist/fp/isSameMinute.js
var isSameMinute2 = convertToFP(isSameMinute, 2);
// dist/isSameMonth.js
function isSameMonth(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}

// dist/fp/isSameMonth.js
var isSameMonth2 = convertToFP(isSameMonth, 2);
// dist/fp/isSameMonthWithOptions.js
var isSameMonthWithOptions = convertToFP(isSameMonth, 3);
// dist/isSameQuarter.js
function isSameQuarter(laterDate, earlierDate, options) {
  const [dateLeft_, dateRight_] = normalizeDates(options?.in, laterDate, earlierDate);
  return +startOfQuarter(dateLeft_) === +startOfQuarter(dateRight_);
}

// dist/fp/isSameQuarter.js
var isSameQuarter2 = convertToFP(isSameQuarter, 2);
// dist/fp/isSameQuarterWithOptions.js
var isSameQuarterWithOptions = convertToFP(isSameQuarter, 3);
// dist/startOfSecond.js
function startOfSecond(date, options) {
  const date_ = toDate(date, options?.in);
  date_.setMilliseconds(0);
  return date_;
}

// dist/isSameSecond.js
function isSameSecond(laterDate, earlierDate) {
  return +startOfSecond(laterDate) === +startOfSecond(earlierDate);
}

// dist/fp/isSameSecond.js
var isSameSecond2 = convertToFP(isSameSecond, 2);
// dist/fp/isSameWeek.js
var isSameWeek2 = convertToFP(isSameWeek, 2);
// dist/fp/isSameWeekWithOptions.js
var isSameWeekWithOptions = convertToFP(isSameWeek, 3);
// dist/isSameYear.js
function isSameYear(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
  return laterDate_.getFullYear() === earlierDate_.getFullYear();
}

// dist/fp/isSameYear.js
var isSameYear2 = convertToFP(isSameYear, 2);
// dist/fp/isSameYearWithOptions.js
var isSameYearWithOptions = convertToFP(isSameYear, 3);
// dist/fp/isSaturday.js
var isSaturday2 = convertToFP(isSaturday, 1);
// dist/fp/isSaturdayWithOptions.js
var isSaturdayWithOptions = convertToFP(isSaturday, 2);
// dist/fp/isSunday.js
var isSunday2 = convertToFP(isSunday, 1);
// dist/fp/isSundayWithOptions.js
var isSundayWithOptions = convertToFP(isSunday, 2);
// dist/isThursday.js
function isThursday(date, options) {
  return toDate(date, options?.in).getDay() === 4;
}

// dist/fp/isThursday.js
var isThursday2 = convertToFP(isThursday, 1);
// dist/fp/isThursdayWithOptions.js
var isThursdayWithOptions = convertToFP(isThursday, 2);
// dist/isTuesday.js
function isTuesday(date, options) {
  return toDate(date, options?.in).getDay() === 2;
}

// dist/fp/isTuesday.js
var isTuesday2 = convertToFP(isTuesday, 1);
// dist/fp/isTuesdayWithOptions.js
var isTuesdayWithOptions = convertToFP(isTuesday, 2);
// dist/fp/isValid.js
var isValid2 = convertToFP(isValid, 1);
// dist/isWednesday.js
function isWednesday(date, options) {
  return toDate(date, options?.in).getDay() === 3;
}

// dist/fp/isWednesday.js
var isWednesday2 = convertToFP(isWednesday, 1);
// dist/fp/isWednesdayWithOptions.js
var isWednesdayWithOptions = convertToFP(isWednesday, 2);
// dist/fp/isWeekend.js
var isWeekend2 = convertToFP(isWeekend, 1);
// dist/fp/isWeekendWithOptions.js
var isWeekendWithOptions = convertToFP(isWeekend, 2);
// dist/isWithinInterval.js
function isWithinInterval(date, interval3, options) {
  const time = +toDate(date, options?.in);
  const [startTime, endTime] = [
    +toDate(interval3.start, options?.in),
    +toDate(interval3.end, options?.in)
  ].sort((a, b) => a - b);
  return time >= startTime && time <= endTime;
}

// dist/fp/isWithinInterval.js
var isWithinInterval2 = convertToFP(isWithinInterval, 2);
// dist/fp/isWithinIntervalWithOptions.js
var isWithinIntervalWithOptions = convertToFP(isWithinInterval, 3);
// dist/lastDayOfDecade.js
function lastDayOfDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return toDate(_date, options?.in);
}

// dist/fp/lastDayOfDecade.js
var lastDayOfDecade2 = convertToFP(lastDayOfDecade, 1);
// dist/fp/lastDayOfDecadeWithOptions.js
var lastDayOfDecadeWithOptions = convertToFP(lastDayOfDecade, 2);
// dist/lastDayOfWeek.js
function lastDayOfWeek(date, options) {
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions2.weekStartsOn ?? defaultOptions2.locale?.options?.weekStartsOn ?? 0;
  const _date = toDate(date, options?.in);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setHours(0, 0, 0, 0);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

// dist/lastDayOfISOWeek.js
function lastDayOfISOWeek(date, options) {
  return lastDayOfWeek(date, { ...options, weekStartsOn: 1 });
}

// dist/fp/lastDayOfISOWeek.js
var lastDayOfISOWeek2 = convertToFP(lastDayOfISOWeek, 1);
// dist/fp/lastDayOfISOWeekWithOptions.js
var lastDayOfISOWeekWithOptions = convertToFP(lastDayOfISOWeek, 2);
// dist/lastDayOfISOWeekYear.js
function lastDayOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuary = constructFrom(options?.in || date, 0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  const date_ = startOfISOWeek(fourthOfJanuary, options);
  date_.setDate(date_.getDate() - 1);
  return date_;
}

// dist/fp/lastDayOfISOWeekYear.js
var lastDayOfISOWeekYear2 = convertToFP(lastDayOfISOWeekYear, 1);
// dist/fp/lastDayOfISOWeekYearWithOptions.js
var lastDayOfISOWeekYearWithOptions = convertToFP(lastDayOfISOWeekYear, 2);
// dist/fp/lastDayOfMonth.js
var lastDayOfMonth2 = convertToFP(lastDayOfMonth, 1);
// dist/fp/lastDayOfMonthWithOptions.js
var lastDayOfMonthWithOptions = convertToFP(lastDayOfMonth, 2);
// dist/lastDayOfQuarter.js
function lastDayOfQuarter(date, options) {
  const date_ = toDate(date, options?.in);
  const currentMonth = date_.getMonth();
  const month = currentMonth - currentMonth % 3 + 3;
  date_.setMonth(month, 0);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

// dist/fp/lastDayOfQuarter.js
var lastDayOfQuarter2 = convertToFP(lastDayOfQuarter, 1);
// dist/fp/lastDayOfQuarterWithOptions.js
var lastDayOfQuarterWithOptions = convertToFP(lastDayOfQuarter, 2);
// dist/fp/lastDayOfWeek.js
var lastDayOfWeek2 = convertToFP(lastDayOfWeek, 1);
// dist/fp/lastDayOfWeekWithOptions.js
var lastDayOfWeekWithOptions = convertToFP(lastDayOfWeek, 2);
// dist/lastDayOfYear.js
function lastDayOfYear(date, options) {
  const date_ = toDate(date, options?.in);
  const year = date_.getFullYear();
  date_.setFullYear(year + 1, 0, 0);
  date_.setHours(0, 0, 0, 0);
  return date_;
}

// dist/fp/lastDayOfYear.js
var lastDayOfYear2 = convertToFP(lastDayOfYear, 1);
// dist/fp/lastDayOfYearWithOptions.js
var lastDayOfYearWithOptions = convertToFP(lastDayOfYear, 2);
// dist/lightFormat.js
var formattingTokensRegExp3 = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp3 = /^'([^]*?)'?$/;
var doubleQuoteRegExp3 = /''/g;
var unescapedLatinCharacterRegExp3 = /[a-zA-Z]/;
function lightFormat(date, formatStr) {
  const date_ = toDate(date);
  if (!isValid(date_)) {
    throw new RangeError("Invalid time value");
  }
  const tokens = formatStr.match(formattingTokensRegExp3);
  if (!tokens)
    return "";
  const result = tokens.map((substring) => {
    if (substring === "''") {
      return "'";
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString3(substring);
    }
    const formatter = lightFormatters[firstCharacter];
    if (formatter) {
      return formatter(date_, substring);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp3)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString3(input) {
  const matches = input.match(escapedStringRegExp3);
  if (!matches)
    return input;
  return matches[1].replace(doubleQuoteRegExp3, "'");
}

// dist/fp/lightFormat.js
var lightFormat2 = convertToFP(lightFormat, 2);
// dist/fp/max.js
var max2 = convertToFP(max, 1);
// dist/fp/maxWithOptions.js
var maxWithOptions = convertToFP(max, 2);
// dist/milliseconds.js
function milliseconds({
  years,
  months: months2,
  weeks,
  days: days2,
  hours,
  minutes,
  seconds
}) {
  let totalDays = 0;
  if (years)
    totalDays += years * daysInYear;
  if (months2)
    totalDays += months2 * (daysInYear / 12);
  if (weeks)
    totalDays += weeks * 7;
  if (days2)
    totalDays += days2;
  let totalSeconds = totalDays * 24 * 60 * 60;
  if (hours)
    totalSeconds += hours * 60 * 60;
  if (minutes)
    totalSeconds += minutes * 60;
  if (seconds)
    totalSeconds += seconds;
  return Math.trunc(totalSeconds * 1000);
}

// dist/fp/milliseconds.js
var milliseconds2 = convertToFP(milliseconds, 1);
// dist/millisecondsToHours.js
function millisecondsToHours(milliseconds3) {
  const hours = milliseconds3 / millisecondsInHour;
  return Math.trunc(hours);
}

// dist/fp/millisecondsToHours.js
var millisecondsToHours2 = convertToFP(millisecondsToHours, 1);
// dist/millisecondsToMinutes.js
function millisecondsToMinutes(milliseconds3) {
  const minutes = milliseconds3 / millisecondsInMinute;
  return Math.trunc(minutes);
}

// dist/fp/millisecondsToMinutes.js
var millisecondsToMinutes2 = convertToFP(millisecondsToMinutes, 1);
// dist/millisecondsToSeconds.js
function millisecondsToSeconds(milliseconds3) {
  const seconds = milliseconds3 / millisecondsInSecond;
  return Math.trunc(seconds);
}

// dist/fp/millisecondsToSeconds.js
var millisecondsToSeconds2 = convertToFP(millisecondsToSeconds, 1);
// dist/fp/min.js
var min2 = convertToFP(min, 1);
// dist/fp/minWithOptions.js
var minWithOptions = convertToFP(min, 2);
// dist/minutesToHours.js
function minutesToHours(minutes) {
  const hours = minutes / minutesInHour;
  return Math.trunc(hours);
}

// dist/fp/minutesToHours.js
var minutesToHours2 = convertToFP(minutesToHours, 1);
// dist/minutesToMilliseconds.js
function minutesToMilliseconds(minutes) {
  return Math.trunc(minutes * millisecondsInMinute);
}

// dist/fp/minutesToMilliseconds.js
var minutesToMilliseconds2 = convertToFP(minutesToMilliseconds, 1);
// dist/minutesToSeconds.js
function minutesToSeconds(minutes) {
  return Math.trunc(minutes * secondsInMinute);
}

// dist/fp/minutesToSeconds.js
var minutesToSeconds2 = convertToFP(minutesToSeconds, 1);
// dist/monthsToQuarters.js
function monthsToQuarters(months2) {
  const quarters = months2 / monthsInQuarter;
  return Math.trunc(quarters);
}

// dist/fp/monthsToQuarters.js
var monthsToQuarters2 = convertToFP(monthsToQuarters, 1);
// dist/monthsToYears.js
function monthsToYears(months2) {
  const years = months2 / monthsInYear;
  return Math.trunc(years);
}

// dist/fp/monthsToYears.js
var monthsToYears2 = convertToFP(monthsToYears, 1);
// dist/nextDay.js
function nextDay(date, day, options) {
  let delta = day - getDay(date, options);
  if (delta <= 0)
    delta += 7;
  return addDays(date, delta, options);
}

// dist/fp/nextDay.js
var nextDay2 = convertToFP(nextDay, 2);
// dist/fp/nextDayWithOptions.js
var nextDayWithOptions = convertToFP(nextDay, 3);
// dist/nextFriday.js
function nextFriday(date, options) {
  return nextDay(date, 5, options);
}

// dist/fp/nextFriday.js
var nextFriday2 = convertToFP(nextFriday, 1);
// dist/fp/nextFridayWithOptions.js
var nextFridayWithOptions = convertToFP(nextFriday, 2);
// dist/nextMonday.js
function nextMonday(date, options) {
  return nextDay(date, 1, options);
}

// dist/fp/nextMonday.js
var nextMonday2 = convertToFP(nextMonday, 1);
// dist/fp/nextMondayWithOptions.js
var nextMondayWithOptions = convertToFP(nextMonday, 2);
// dist/nextSaturday.js
function nextSaturday(date, options) {
  return nextDay(date, 6, options);
}

// dist/fp/nextSaturday.js
var nextSaturday2 = convertToFP(nextSaturday, 1);
// dist/fp/nextSaturdayWithOptions.js
var nextSaturdayWithOptions = convertToFP(nextSaturday, 2);
// dist/nextSunday.js
function nextSunday(date, options) {
  return nextDay(date, 0, options);
}

// dist/fp/nextSunday.js
var nextSunday2 = convertToFP(nextSunday, 1);
// dist/fp/nextSundayWithOptions.js
var nextSundayWithOptions = convertToFP(nextSunday, 2);
// dist/nextThursday.js
function nextThursday(date, options) {
  return nextDay(date, 4, options);
}

// dist/fp/nextThursday.js
var nextThursday2 = convertToFP(nextThursday, 1);
// dist/fp/nextThursdayWithOptions.js
var nextThursdayWithOptions = convertToFP(nextThursday, 2);
// dist/nextTuesday.js
function nextTuesday(date, options) {
  return nextDay(date, 2, options);
}

// dist/fp/nextTuesday.js
var nextTuesday2 = convertToFP(nextTuesday, 1);
// dist/fp/nextTuesdayWithOptions.js
var nextTuesdayWithOptions = convertToFP(nextTuesday, 2);
// dist/nextWednesday.js
function nextWednesday(date, options) {
  return nextDay(date, 3, options);
}

// dist/fp/nextWednesday.js
var nextWednesday2 = convertToFP(nextWednesday, 1);
// dist/fp/nextWednesdayWithOptions.js
var nextWednesdayWithOptions = convertToFP(nextWednesday, 2);
// dist/fp/parse.js
var parse2 = convertToFP(parse, 3);
// dist/parseISO.js
function parseISO(argument, options) {
  const invalidDate = () => constructFrom(options?.in, NaN);
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);
  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(+date))
    return invalidDate();
  const timestamp = +date;
  let time = 0;
  let offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time))
      return invalidDate();
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset))
      return invalidDate();
  } else {
    const tmpDate = new Date(timestamp + time);
    const result = toDate(0, options?.in);
    result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
    result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
    return result;
  }
  return toDate(timestamp + time + offset, options?.in);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  const captures = dateString.match(regex);
  if (!captures)
    return { year: NaN, restDateString: "" };
  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null)
    return new Date(NaN);
  const captures = dateString.match(dateRegex);
  if (!captures)
    return new Date(NaN);
  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures)
    return NaN;
  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z")
    return 0;
  const captures = timezoneString.match(timezoneRegex);
  if (!captures)
    return 0;
  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex2(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex2(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex2(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

// dist/fp/parseISO.js
var parseISO2 = convertToFP(parseISO, 1);
// dist/fp/parseISOWithOptions.js
var parseISOWithOptions = convertToFP(parseISO, 2);
// dist/parseJSON.js
function parseJSON(dateStr, options) {
  const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
  if (!parts)
    return toDate(NaN, options?.in);
  return toDate(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)), options?.in);
}

// dist/fp/parseJSON.js
var parseJSON2 = convertToFP(parseJSON, 1);
// dist/fp/parseJSONWithOptions.js
var parseJSONWithOptions = convertToFP(parseJSON, 2);
// dist/fp/parseWithOptions.js
var parseWithOptions = convertToFP(parse, 4);
// dist/subDays.js
function subDays(date, amount, options) {
  return addDays(date, -amount, options);
}

// dist/previousDay.js
function previousDay(date, day, options) {
  let delta = getDay(date, options) - day;
  if (delta <= 0)
    delta += 7;
  return subDays(date, delta, options);
}

// dist/fp/previousDay.js
var previousDay2 = convertToFP(previousDay, 2);
// dist/fp/previousDayWithOptions.js
var previousDayWithOptions = convertToFP(previousDay, 3);
// dist/previousFriday.js
function previousFriday(date, options) {
  return previousDay(date, 5, options);
}

// dist/fp/previousFriday.js
var previousFriday2 = convertToFP(previousFriday, 1);
// dist/fp/previousFridayWithOptions.js
var previousFridayWithOptions = convertToFP(previousFriday, 2);
// dist/previousMonday.js
function previousMonday(date, options) {
  return previousDay(date, 1, options);
}

// dist/fp/previousMonday.js
var previousMonday2 = convertToFP(previousMonday, 1);
// dist/fp/previousMondayWithOptions.js
var previousMondayWithOptions = convertToFP(previousMonday, 2);
// dist/previousSaturday.js
function previousSaturday(date, options) {
  return previousDay(date, 6, options);
}

// dist/fp/previousSaturday.js
var previousSaturday2 = convertToFP(previousSaturday, 1);
// dist/fp/previousSaturdayWithOptions.js
var previousSaturdayWithOptions = convertToFP(previousSaturday, 2);
// dist/previousSunday.js
function previousSunday(date, options) {
  return previousDay(date, 0, options);
}

// dist/fp/previousSunday.js
var previousSunday2 = convertToFP(previousSunday, 1);
// dist/fp/previousSundayWithOptions.js
var previousSundayWithOptions = convertToFP(previousSunday, 2);
// dist/previousThursday.js
function previousThursday(date, options) {
  return previousDay(date, 4, options);
}

// dist/fp/previousThursday.js
var previousThursday2 = convertToFP(previousThursday, 1);
// dist/fp/previousThursdayWithOptions.js
var previousThursdayWithOptions = convertToFP(previousThursday, 2);
// dist/previousTuesday.js
function previousTuesday(date, options) {
  return previousDay(date, 2, options);
}

// dist/fp/previousTuesday.js
var previousTuesday2 = convertToFP(previousTuesday, 1);
// dist/fp/previousTuesdayWithOptions.js
var previousTuesdayWithOptions = convertToFP(previousTuesday, 2);
// dist/previousWednesday.js
function previousWednesday(date, options) {
  return previousDay(date, 3, options);
}

// dist/fp/previousWednesday.js
var previousWednesday2 = convertToFP(previousWednesday, 1);
// dist/fp/previousWednesdayWithOptions.js
var previousWednesdayWithOptions = convertToFP(previousWednesday, 2);
// dist/quartersToMonths.js
function quartersToMonths(quarters) {
  return Math.trunc(quarters * monthsInQuarter);
}

// dist/fp/quartersToMonths.js
var quartersToMonths2 = convertToFP(quartersToMonths, 1);
// dist/quartersToYears.js
function quartersToYears(quarters) {
  const years = quarters / quartersInYear;
  return Math.trunc(years);
}

// dist/fp/quartersToYears.js
var quartersToYears2 = convertToFP(quartersToYears, 1);
// dist/roundToNearestHours.js
function roundToNearestHours(date, options) {
  const nearestTo = options?.nearestTo ?? 1;
  if (nearestTo < 1 || nearestTo > 12)
    return constructFrom(options?.in || date, NaN);
  const date_ = toDate(date, options?.in);
  const fractionalMinutes = date_.getMinutes() / 60;
  const fractionalSeconds = date_.getSeconds() / 60 / 60;
  const fractionalMilliseconds = date_.getMilliseconds() / 1000 / 60 / 60;
  const hours = date_.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = getRoundingMethod(method);
  const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
  date_.setHours(roundedHours, 0, 0, 0);
  return date_;
}

// dist/fp/roundToNearestHours.js
var roundToNearestHours2 = convertToFP(roundToNearestHours, 1);
// dist/fp/roundToNearestHoursWithOptions.js
var roundToNearestHoursWithOptions = convertToFP(roundToNearestHours, 2);
// dist/roundToNearestMinutes.js
function roundToNearestMinutes(date, options) {
  const nearestTo = options?.nearestTo ?? 1;
  if (nearestTo < 1 || nearestTo > 30)
    return constructFrom(date, NaN);
  const date_ = toDate(date, options?.in);
  const fractionalSeconds = date_.getSeconds() / 60;
  const fractionalMilliseconds = date_.getMilliseconds() / 1000 / 60;
  const minutes = date_.getMinutes() + fractionalSeconds + fractionalMilliseconds;
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = getRoundingMethod(method);
  const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
  date_.setMinutes(roundedMinutes, 0, 0);
  return date_;
}

// dist/fp/roundToNearestMinutes.js
var roundToNearestMinutes2 = convertToFP(roundToNearestMinutes, 1);
// dist/fp/roundToNearestMinutesWithOptions.js
var roundToNearestMinutesWithOptions = convertToFP(roundToNearestMinutes, 2);
// dist/secondsToHours.js
function secondsToHours(seconds) {
  const hours = seconds / secondsInHour;
  return Math.trunc(hours);
}

// dist/fp/secondsToHours.js
var secondsToHours2 = convertToFP(secondsToHours, 1);
// dist/secondsToMilliseconds.js
function secondsToMilliseconds(seconds) {
  return seconds * millisecondsInSecond;
}

// dist/fp/secondsToMilliseconds.js
var secondsToMilliseconds2 = convertToFP(secondsToMilliseconds, 1);
// dist/secondsToMinutes.js
function secondsToMinutes(seconds) {
  const minutes = seconds / secondsInMinute;
  return Math.trunc(minutes);
}

// dist/fp/secondsToMinutes.js
var secondsToMinutes2 = convertToFP(secondsToMinutes, 1);
// dist/setMonth.js
function setMonth(date, month, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const day = _date.getDate();
  const midMonth = constructFrom(options?.in || date, 0);
  midMonth.setFullYear(year, month, 15);
  midMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(midMonth);
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}

// dist/set.js
function set(date, values, options) {
  let _date = toDate(date, options?.in);
  if (isNaN(+_date))
    return constructFrom(options?.in || date, NaN);
  if (values.year != null)
    _date.setFullYear(values.year);
  if (values.month != null)
    _date = setMonth(_date, values.month);
  if (values.date != null)
    _date.setDate(values.date);
  if (values.hours != null)
    _date.setHours(values.hours);
  if (values.minutes != null)
    _date.setMinutes(values.minutes);
  if (values.seconds != null)
    _date.setSeconds(values.seconds);
  if (values.milliseconds != null)
    _date.setMilliseconds(values.milliseconds);
  return _date;
}

// dist/fp/set.js
var set2 = convertToFP(set, 2);
// dist/setDate.js
function setDate(date, dayOfMonth, options) {
  const _date = toDate(date, options?.in);
  _date.setDate(dayOfMonth);
  return _date;
}

// dist/fp/setDate.js
var setDate2 = convertToFP(setDate, 2);
// dist/fp/setDateWithOptions.js
var setDateWithOptions = convertToFP(setDate, 3);
// dist/fp/setDay.js
var setDay2 = convertToFP(setDay, 2);
// dist/setDayOfYear.js
function setDayOfYear(date, dayOfYear, options) {
  const date_ = toDate(date, options?.in);
  date_.setMonth(0);
  date_.setDate(dayOfYear);
  return date_;
}

// dist/fp/setDayOfYear.js
var setDayOfYear2 = convertToFP(setDayOfYear, 2);
// dist/fp/setDayOfYearWithOptions.js
var setDayOfYearWithOptions = convertToFP(setDayOfYear, 3);
// dist/fp/setDayWithOptions.js
var setDayWithOptions = convertToFP(setDay, 3);
// dist/setHours.js
function setHours(date, hours, options) {
  const _date = toDate(date, options?.in);
  _date.setHours(hours);
  return _date;
}

// dist/fp/setHours.js
var setHours2 = convertToFP(setHours, 2);
// dist/fp/setHoursWithOptions.js
var setHoursWithOptions = convertToFP(setHours, 3);
// dist/fp/setISODay.js
var setISODay2 = convertToFP(setISODay, 2);
// dist/fp/setISODayWithOptions.js
var setISODayWithOptions = convertToFP(setISODay, 3);
// dist/fp/setISOWeek.js
var setISOWeek2 = convertToFP(setISOWeek, 2);
// dist/fp/setISOWeekWithOptions.js
var setISOWeekWithOptions = convertToFP(setISOWeek, 3);
// dist/fp/setISOWeekYear.js
var setISOWeekYear2 = convertToFP(setISOWeekYear, 2);
// dist/fp/setISOWeekYearWithOptions.js
var setISOWeekYearWithOptions = convertToFP(setISOWeekYear, 3);
// dist/setMilliseconds.js
function setMilliseconds(date, milliseconds3, options) {
  const _date = toDate(date, options?.in);
  _date.setMilliseconds(milliseconds3);
  return _date;
}

// dist/fp/setMilliseconds.js
var setMilliseconds2 = convertToFP(setMilliseconds, 2);
// dist/fp/setMillisecondsWithOptions.js
var setMillisecondsWithOptions = convertToFP(setMilliseconds, 3);
// dist/setMinutes.js
function setMinutes(date, minutes, options) {
  const date_ = toDate(date, options?.in);
  date_.setMinutes(minutes);
  return date_;
}

// dist/fp/setMinutes.js
var setMinutes2 = convertToFP(setMinutes, 2);
// dist/fp/setMinutesWithOptions.js
var setMinutesWithOptions = convertToFP(setMinutes, 3);
// dist/fp/setMonth.js
var setMonth2 = convertToFP(setMonth, 2);
// dist/fp/setMonthWithOptions.js
var setMonthWithOptions = convertToFP(setMonth, 3);
// dist/setQuarter.js
function setQuarter(date, quarter, options) {
  const date_ = toDate(date, options?.in);
  const oldQuarter = Math.trunc(date_.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return setMonth(date_, date_.getMonth() + diff * 3);
}

// dist/fp/setQuarter.js
var setQuarter2 = convertToFP(setQuarter, 2);
// dist/fp/setQuarterWithOptions.js
var setQuarterWithOptions = convertToFP(setQuarter, 3);
// dist/setSeconds.js
function setSeconds(date, seconds, options) {
  const _date = toDate(date, options?.in);
  _date.setSeconds(seconds);
  return _date;
}

// dist/fp/setSeconds.js
var setSeconds2 = convertToFP(setSeconds, 2);
// dist/fp/setSecondsWithOptions.js
var setSecondsWithOptions = convertToFP(setSeconds, 3);
// dist/fp/setWeek.js
var setWeek2 = convertToFP(setWeek, 2);
// dist/fp/setWeekWithOptions.js
var setWeekWithOptions = convertToFP(setWeek, 3);
// dist/setWeekYear.js
function setWeekYear(date, weekYear, options) {
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions2.firstWeekContainsDate ?? defaultOptions2.locale?.options?.firstWeekContainsDate ?? 1;
  const diff = differenceInCalendarDays(toDate(date, options?.in), startOfWeekYear(date, options), options);
  const firstWeek = constructFrom(options?.in || date, 0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const date_ = startOfWeekYear(firstWeek, options);
  date_.setDate(date_.getDate() + diff);
  return date_;
}

// dist/fp/setWeekYear.js
var setWeekYear2 = convertToFP(setWeekYear, 2);
// dist/fp/setWeekYearWithOptions.js
var setWeekYearWithOptions = convertToFP(setWeekYear, 3);
// dist/fp/setWithOptions.js
var setWithOptions = convertToFP(set, 3);
// dist/setYear.js
function setYear(date, year, options) {
  const date_ = toDate(date, options?.in);
  if (isNaN(+date_))
    return constructFrom(options?.in || date, NaN);
  date_.setFullYear(year);
  return date_;
}

// dist/fp/setYear.js
var setYear2 = convertToFP(setYear, 2);
// dist/fp/setYearWithOptions.js
var setYearWithOptions = convertToFP(setYear, 3);
// dist/fp/startOfDay.js
var startOfDay2 = convertToFP(startOfDay, 1);
// dist/fp/startOfDayWithOptions.js
var startOfDayWithOptions = convertToFP(startOfDay, 2);
// dist/startOfDecade.js
function startOfDecade(date, options) {
  const _date = toDate(date, options?.in);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// dist/fp/startOfDecade.js
var startOfDecade2 = convertToFP(startOfDecade, 1);
// dist/fp/startOfDecadeWithOptions.js
var startOfDecadeWithOptions = convertToFP(startOfDecade, 2);
// dist/fp/startOfHour.js
var startOfHour2 = convertToFP(startOfHour, 1);
// dist/fp/startOfHourWithOptions.js
var startOfHourWithOptions = convertToFP(startOfHour, 2);
// dist/fp/startOfISOWeek.js
var startOfISOWeek2 = convertToFP(startOfISOWeek, 1);
// dist/fp/startOfISOWeekWithOptions.js
var startOfISOWeekWithOptions = convertToFP(startOfISOWeek, 2);
// dist/fp/startOfISOWeekYear.js
var startOfISOWeekYear2 = convertToFP(startOfISOWeekYear, 1);
// dist/fp/startOfISOWeekYearWithOptions.js
var startOfISOWeekYearWithOptions = convertToFP(startOfISOWeekYear, 2);
// dist/fp/startOfMinute.js
var startOfMinute2 = convertToFP(startOfMinute, 1);
// dist/fp/startOfMinuteWithOptions.js
var startOfMinuteWithOptions = convertToFP(startOfMinute, 2);
// dist/fp/startOfMonth.js
var startOfMonth2 = convertToFP(startOfMonth, 1);
// dist/fp/startOfMonthWithOptions.js
var startOfMonthWithOptions = convertToFP(startOfMonth, 2);
// dist/fp/startOfQuarter.js
var startOfQuarter2 = convertToFP(startOfQuarter, 1);
// dist/fp/startOfQuarterWithOptions.js
var startOfQuarterWithOptions = convertToFP(startOfQuarter, 2);
// dist/fp/startOfSecond.js
var startOfSecond2 = convertToFP(startOfSecond, 1);
// dist/fp/startOfSecondWithOptions.js
var startOfSecondWithOptions = convertToFP(startOfSecond, 2);
// dist/fp/startOfWeek.js
var startOfWeek2 = convertToFP(startOfWeek, 1);
// dist/fp/startOfWeekWithOptions.js
var startOfWeekWithOptions = convertToFP(startOfWeek, 2);
// dist/fp/startOfWeekYear.js
var startOfWeekYear2 = convertToFP(startOfWeekYear, 1);
// dist/fp/startOfWeekYearWithOptions.js
var startOfWeekYearWithOptions = convertToFP(startOfWeekYear, 2);
// dist/fp/startOfYear.js
var startOfYear2 = convertToFP(startOfYear, 1);
// dist/fp/startOfYearWithOptions.js
var startOfYearWithOptions = convertToFP(startOfYear, 2);
// dist/subMonths.js
function subMonths(date, amount, options) {
  return addMonths(date, -amount, options);
}

// dist/sub.js
function sub(date, duration, options) {
  const {
    years = 0,
    months: months2 = 0,
    weeks = 0,
    days: days2 = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const withoutMonths = subMonths(date, months2 + years * 12, options);
  const withoutDays = subDays(withoutMonths, days2 + weeks * 7, options);
  const minutesToSub = minutes + hours * 60;
  const secondsToSub = seconds + minutesToSub * 60;
  const msToSub = secondsToSub * 1000;
  return constructFrom(options?.in || date, +withoutDays - msToSub);
}

// dist/fp/sub.js
var sub2 = convertToFP(sub, 2);
// dist/subBusinessDays.js
function subBusinessDays(date, amount, options) {
  return addBusinessDays(date, -amount, options);
}

// dist/fp/subBusinessDays.js
var subBusinessDays2 = convertToFP(subBusinessDays, 2);
// dist/fp/subBusinessDaysWithOptions.js
var subBusinessDaysWithOptions = convertToFP(subBusinessDays, 3);
// dist/fp/subDays.js
var subDays2 = convertToFP(subDays, 2);
// dist/fp/subDaysWithOptions.js
var subDaysWithOptions = convertToFP(subDays, 3);
// dist/subHours.js
function subHours(date, amount, options) {
  return addHours(date, -amount, options);
}

// dist/fp/subHours.js
var subHours2 = convertToFP(subHours, 2);
// dist/fp/subHoursWithOptions.js
var subHoursWithOptions = convertToFP(subHours, 3);
// dist/fp/subISOWeekYears.js
var subISOWeekYears2 = convertToFP(subISOWeekYears, 2);
// dist/fp/subISOWeekYearsWithOptions.js
var subISOWeekYearsWithOptions = convertToFP(subISOWeekYears, 3);
// dist/subMilliseconds.js
function subMilliseconds(date, amount, options) {
  return addMilliseconds(date, -amount, options);
}

// dist/fp/subMilliseconds.js
var subMilliseconds2 = convertToFP(subMilliseconds, 2);
// dist/fp/subMillisecondsWithOptions.js
var subMillisecondsWithOptions = convertToFP(subMilliseconds, 3);
// dist/subMinutes.js
function subMinutes(date, amount, options) {
  return addMinutes(date, -amount, options);
}

// dist/fp/subMinutes.js
var subMinutes2 = convertToFP(subMinutes, 2);
// dist/fp/subMinutesWithOptions.js
var subMinutesWithOptions = convertToFP(subMinutes, 3);
// dist/fp/subMonths.js
var subMonths2 = convertToFP(subMonths, 2);
// dist/fp/subMonthsWithOptions.js
var subMonthsWithOptions = convertToFP(subMonths, 3);
// dist/subQuarters.js
function subQuarters(date, amount, options) {
  return addQuarters(date, -amount, options);
}

// dist/fp/subQuarters.js
var subQuarters2 = convertToFP(subQuarters, 2);
// dist/fp/subQuartersWithOptions.js
var subQuartersWithOptions = convertToFP(subQuarters, 3);
// dist/subSeconds.js
function subSeconds(date, amount, options) {
  return addSeconds(date, -amount, options);
}

// dist/fp/subSeconds.js
var subSeconds2 = convertToFP(subSeconds, 2);
// dist/fp/subSecondsWithOptions.js
var subSecondsWithOptions = convertToFP(subSeconds, 3);
// dist/subWeeks.js
function subWeeks(date, amount, options) {
  return addWeeks(date, -amount, options);
}

// dist/fp/subWeeks.js
var subWeeks2 = convertToFP(subWeeks, 2);
// dist/fp/subWeeksWithOptions.js
var subWeeksWithOptions = convertToFP(subWeeks, 3);
// dist/fp/subWithOptions.js
var subWithOptions = convertToFP(sub, 3);
// dist/subYears.js
function subYears(date, amount, options) {
  return addYears(date, -amount, options);
}

// dist/fp/subYears.js
var subYears2 = convertToFP(subYears, 2);
// dist/fp/subYearsWithOptions.js
var subYearsWithOptions = convertToFP(subYears, 3);
// dist/fp/toDate.js
var toDate2 = convertToFP(toDate, 2);
// dist/fp/transpose.js
var transpose2 = convertToFP(transpose, 2);
// dist/weeksToDays.js
function weeksToDays(weeks) {
  return Math.trunc(weeks * daysInWeek);
}

// dist/fp/weeksToDays.js
var weeksToDays2 = convertToFP(weeksToDays, 1);
// dist/yearsToDays.js
function yearsToDays(years) {
  return Math.trunc(years * daysInYear);
}

// dist/fp/yearsToDays.js
var yearsToDays2 = convertToFP(yearsToDays, 1);
// dist/yearsToMonths.js
function yearsToMonths(years) {
  return Math.trunc(years * monthsInYear);
}

// dist/fp/yearsToMonths.js
var yearsToMonths2 = convertToFP(yearsToMonths, 1);
// dist/yearsToQuarters.js
function yearsToQuarters(years) {
  return Math.trunc(years * quartersInYear);
}

// dist/fp/yearsToQuarters.js
var yearsToQuarters2 = convertToFP(yearsToQuarters, 1);
// dist/fp/cdn.js
window.dateFns = {
  ...window.dateFns,
  fp: exports_fp
};

//# debugId=69F0AA2BDF27F80864756E2164756E21
